import { IMG_PMK_CONVENTIONAL_1 } from "../../../../assets";

export const tcConventionalContent = [
  {
    content: "Definisi",
    tag: "1.",
    child: [
      {
        tag: "1.1",
        content:
          "Dalam Perjanjian ini, kecuali apabila konteksnya secara tegas menyatakan atau mensyaratkan lain, maka kata-kata sebagaimana dimaksud di bawah ini memiliki arti sebagai berikut:",
        child: [
          {
            tag: "1.1.1",
            content:
              "<b>”Agen”</b> adalah Agen Perusahaan berdasarkan Perjanjian Keagenan dengan Perusahaan yang masih berlaku.",
          },
          {
            tag: "1.1.2",
            content: "<b>”AAJI”</b>  adalah  Asosiasi  Asuransi  Jiwa  Indonesia.",
          },
          {
            tag: "1.1.3",
            content:
              "<b>”<i>AD on AD</i>”</b> adalah para manajer keagenan dengan jabatan <i>Agency Director</i> yang pernah direkrut  secara  langsung  maupun  tidak langsung oleh manajer keagenan lainnya, ketika manajer keagenan tersebut belum menjabat  posisi  <i>Agency  Director</i>  dan  jabatannya ada di bawah manajer keagenan yang merekrut, di mana manajer keagenan yang merekrut tersebut berhak menerima <i>overriding AD on AD</i> dari manajer keagenan yang direkrut sesuai dengan struktur keagenan yang berlaku di Perusahaan.",
          },
          {
            tag: "1.1.4",
            content:
              "<b>”Cacat Total dan tetap</b> adalah cacat sebagai akibat dari Kecelakaan atau penyakit yang menyebabkan:",
            content2:
              "Sedangkan ”Kecelakaan” merupakan peristiwa yang tidak diharapkan, terjadi secara tiba-tiba, tidak terduga, tidak disengaja, datangnya dari luar, bersifat kekerasan dan kasat mata.",
            child: [
              {
                tag: "a.",
                content:
                  "Manajer Keagenan  sama sekali tidak dapat melakukan pekerjaan apa pun untuk mencari nafkah secara terus-menerus selama 180 hari terakhir sejak didiagnosa oleh dokter, tidak termasuk cacat berupa kelainan jiwa, cacat mental,  neurosis,  psikosomatis  ataupun psikosis; atau",
              },
              {
                tag: "b.",
                content:
                  "Manajer Keagenan  kehilangan fungsi secara total dan tidak dapat dipulihkan atas anggota tubuh sebagai berikut:",
                child: [
                  {
                    tag: "(1)",
                    content: "Kedua mata, atau",
                    isTagNumber: true,
                  },
                  {
                    tag: "(2)",
                    isTagNumber: true,
                    content:
                      "Kedua lengan atau kedua kaki atau satu lengan dan satu kaki yang terjadi  pada  atau  di  atas  pergelangan  tangan  atau pergelangan kaki, atau",
                  },
                  {
                    tag: "(3)",
                    isTagNumber: true,
                    content:
                      "Satu mata dan satu lengan yang terjadi  pada  atau  di  atas pergelangan tangan, atau",
                  },
                  {
                    tag: "(4)",
                    isTagNumber: true,
                    content:
                      "Satu mata dan satu kaki yang terjadi  pada  atau  di  atas  pergelangan kaki",
                  },
                ],
              },
            ],
          },
          {
            tag: "1.1.5",
            content:
              "<b>“<i>Designated Successor</i>”</b> adalah (1) seorang manajer keagenan dengan jabatan <i>Agency Director; </i> atau (2) seorang tenaga pemasar (Agen, , <i>Associate Agency Director</i> (AAD) atau <i>Agency Director</i> (AD)) yang terdaftar di Perusahaan  yang  telah  memiliki  lisensi keagenan (dalam hal orang tersebut memiliki hubungan  kekeluargaan  dengan  <i>Agency  Director</i>);  yang  telah  ditunjuk  oleh  <i>Agency Director</i>  khusus  sebagai  <i>Designated Successor</i> yang memenuhi syarat yang ditentukan dan disetujui oleh Perusahaan di mana <i>Designated Successor</i> ini bertanggung jawab untuk menjalankan Grup Manajer Keagenan, baik Grup Manajer Keagenan Langsung atau Grup Manajer Keagenan Tidak Langsung, yang sudah dibangun oleh Manajer Keagenan. <i>Designated Successor</i> dapat juga menjadi pihak yang ditunjuk oleh Manajer Keagenan untuk menerima <i>Overriding</i> dari produksi anggota Grup Manajer Keagenan sesuai dengan skema Perusahaan yang berlaku.",
          },
          {
            tag: "1.1.6",
            content: "<b>“Evaluasi”</b> adalah sebagaimana didefinisikan dalam Pasal 6.",
          },
          {
            tag: "1.1.7",
            content:
              "<b>“Grup Manajer Keagenan”</b> adalah grup keagenan yang dimiliki Manajer Keagenan yang terdiri dari Grup Manajer Keagenan Langsung dan/atau  Grup  Manajer  Keagenan  Tidak  Langsung,  mengingat  Manajer  Keagenan  dengan jabatan <i>Associate Agency Director</i> (AAD) hanya memiliki Grup Manajer Keagenan Langsung.",
          },
          {
            tag: "1.1.8",
            content:
              '<b>“Grup Manajer Keagenan Langsung”</b> atau <b>"GMKL"</b> adalah terdiri dari Manajer Keagenan itu sendiri, para agen dan/atau manajer keagenan (kecuali manajer keagenan  yang sejajar atau lebih tinggi jabatannya dari Manajer Keagenan) yang berada di bawah pengawasan Manajer Keagenan baik langsung maupun tidak langsung.',
          },
          {
            tag: "1.1.9",
            content:
              '<b>“Grup Manajer Keagenan Tidak Langsung”</b> atau <b>"GMKTL"</b> adalah grup lain di luar Grup Manajer Keagenan Langsung dari seorang Manajer Keagenan dengan jabatan <i>Agency Director</i>, dimana grup lain tersebut terdiri dari seorang <i>Agency Director</i> dengan Grup Manajer Keagenan Langsungnya, dimana <i>Agency Director</i> tersebut merupakan <i>Agency Director</i> yang terkait langsung dalam hubungan AD on AD dengannya. ',
            contentNoFormat:
              "Untuk menghindari keragu-raguan mengenai Struktur Grup Manajer Keagenan sebagaimana dimaksud pada Pasal 1.1.8, Pasal 1.1.9 dan Pasal 1.1.10, maka berikut adalah contoh dari Grup Manager Keagenan:",
            contentNoFormat2:
              "<i>Agency Director</i> A mempunyai Grup Manajer Keagenan, yang terdiri dari Grup Manajer Keagenan Langsung dan Grup Manajer Keagenan Tidak Langsung, yaitu <i>Agency Director</i> B beserta grup Manajer Keagenan Langsungnya.",
            image: IMG_PMK_CONVENTIONAL_1,
            imageTag: "Struktur Grup Manajer Keagenan",
          },
          {
            tag: "1.1.10",
            content:
              "<b>“Informasi Rahasia”</b> adalah segala informasi rahasia mengenai Perusahaan dan Kelompok Usaha-nya dari waktu ke waktu (dalam bentuk apapun) termasuk tetapi tidak terbatas pada segala informasi mengenai bisnis, keuangan, operasional, nasabah dan <i>marketing, know-how</i> dan rahasia dagang sehubungan dengan bisnis dari Perusahaan dan Kelompok Usaha-nya tersebut dan segala informasi di mana Perusahaan dan Kelompok usahanya terikat untuk menjaga kerahasiaan informasi tersebut ke pihak ketiga.",
            subContent:
              "<b>“Kelompok Usaha”</b> adalah berarti setiap perusahaan di mana Prudential plc dan/atau afiliasinya  menjadi  pemegang  saham  utamanya.",
          },
          {
            tag: "1.1.11",
            content:
              "<b>“Jasa”</b> adalah seluruh jasa yang diberikan oleh Manajer Keagenan kepada Nasabah dan kewajiban yang harus dilakukan Manajer Keagenan berdasarkan Perjanjian ini, termasuk hal-hal sebagaimana diatur dalam Pasal 3.",
          },
          {
            tag: "1.1.12",
            content:
              "<b>“Kekayaan Intelektual”</b> adalah setiap hak paten, hak cipta, hak merek, rahasia dagang, hasil karya, desain, metode, teknik, proses, prosedur, ilustrasi, baik terdaftar maupun tidak, baik dalam bentuk cetak, audio atau video, yang dimiliki dan/atau dibuat oleh Perusahaan.",
          },
          {
            tag: "1.1.13",
            content:
              "<b>“Kerugian”</b> adalah setiap klaim, tanggung jawab, pengeluaran, denda, penalti, biaya, kerugian dalam bentuk apa pun (termasuk biaya hukum).",
          },
          {
            tag: "1.1.14",
            content:
              "<b>“Ketentuan <i>Overriding</i>”</b> sehubungan dengan Produk Asuransi, adalah ketentuan mengenai <i>Overriding</i> yang berhak diterima oleh Manajer Keagenan  berdasarkan  Perjanjian  ini, sebagaimana terlampir dalam Lampiran I Perjanjian  ini,  berdasarkan  kebijakan Perusahaan beserta segala perubahannya dari waktu ke waktu",
          },
          {
            tag: "1.1.15",
            content:
              "<b>“Kode Etik Keagenan”</b> adalah seperangkat aturan dasar tertulis maupun tidak tertulis yang  harus  diperhatikan  dan  dijalankan  Manajer  Keagenan,  termasuk  kode  etik keagenan sebagaimana terlampir dalam Lampiran III beserta segala perubahannya dari waktu ke waktu.",
          },
          {
            tag: "1.1.16",
            content:
              "<b>“Logo Perusahaan”</b> adalah semua nama, tanda-tanda, merek dagang, dan/atau logo Perusahaan.",
          },
          {
            tag: "1.1.17",
            content:
              "<b>“Nasabah”</b> adalah semua orang yang sudah dan/atau berpotensi menjadi Pemegang Polis Perusahaan.",
          },
          {
            tag: "1.1.18",
            content: "<b>“OJK”</b>  adalah  Otoritas  Jasa  Keuangan Republik Indonesia.",
          },
          {
            tag: "1.1.19",
            content:
              "<b>“<i>Overriding</i>”</b>  adalah  <i>Overriding</i>  yang  berhak  diterima  Manajer  Keagenan  sebagaimana diuraikan dalam Pasal 4.",
          },
          {
            tag: "1.1.20",
            content:
              "<b>“<i>Overriding</i>  untuk  <i>Agency  Director</i>  dari  GMKL”</b>  atau  <b>”ORD”</b>  adalah  <i>Overriding</i>  yang  dapat  diterima  oleh  <i>Agency  Director</i>  sehubungan dengan seluruh produksi anggota GMKL baik yang dibuat sebelum maupun setelah Tanggal Rencana Suksesi.",
          },
          {
            tag: "1.1.21",
            content:
              "<b>“<i>Overriding</i>  untuk  </b><b><i>Agency  Director</i>  dari  GMKTL”</b>  atau  <b>”ORI”</b>  adalah  <i>Overriding</i>  yang  dapat  diterima  oleh  <i>Agency  Director</i>  sehubungan dengan seluruh produksi anggota Grup Manajer Keagenan Tidak Langsung baik yang dibuat sebelum maupun setelah Tanggal Rencana Suksesi.",
          },
          {
            tag: "1.1.22",
            content:
              "<b>“Pengganti <i>Agency Director</i>”</b> adalah orang yang ditunjuk oleh Perusahaan dan memiliki tanggung jawab untuk menjalankan Grup Manajer Keagenan yang sudah dibangun oleh <i>Agency Director</i> sehubungan dengan Rencana Suksesi  dari  <i>Agency  Director</i>  yang  bersangkutan.",
          },
          {
            tag: "1.1.23",
            content:
              "<b>“Penangguhan”</b> adalah salah satu bentuk Tindakan Disiplin yang dapat diberikan oleh Perusahaan kepada Manajer Keagenan berupa penangguhan sebagian atau seluruh hak Manajer Keagenan sebagaimana diatur di dalam Pasal 8.3.",
          },
          {
            tag: "1.1.24",
            content:
              "<b>“Peraturan  Keagenan”</b>  adalah  semua  peraturan dan kebijakan yang dikeluarkan dan/atau disosialisasikan oleh Perusahaan dari waktu ke waktu, termasuk namun tidak terbatas pada <b>PRU</b><i>berita</i>, Kode Etik Keagenan, <i>agency update</i>, dan <i>operational update</i>, beserta  segala  penambahan  dan perubahannya dari waktu ke waktu.",
          },
          {
            tag: "1.1.25",
            content:
              "<b>“Peraturan AAJI”</b> adalah peraturan dan kebijakan yang dikeluarkan oleh AAJI beserta segala penambahan dan perubahannya.",
          },
          {
            tag: "1.1.26",
            content:
              "<b>“Perjanjian Keagenan”</b> adalah Perjanjian Keagenan dan dibuat oleh seorang Agen dan Perusahaan.",
          },
          {
            tag: "1.1.27",
            content:
              "<b>“Perjanjian Manajer Keagenan”</b> adalah Perjanjian Manajer Keagenan yang dibuat oleh Manajer Keagenan dan Perusahaan.",
          },
          {
            tag: "1.1.28",
            content:
              "<b>“Produk Asuransi</b> adalah program asuransi jiwa baik non syariah yang ditawarkan dan/atau dipertanggungkan oleh Perusahaan, serta semua program asuransi lainnya yang disetujui dan diterbitkan oleh Perusahaan dari waktu ke waktu.",
          },
          {
            tag: "1.1.29",
            content:
              "<b>”Prudential Syariah”</b> yaitu PT Prudential Sharia Life Assurance, sebuah perusahaan yang memiliki ijin untuk menjalankan bisnis  asuransi  jiwa  berbasis  syariah,  serta merupakan anak perusahaan dari Perusahaan.",
          },
          {
            tag: "1.1.30",
            content:
              "<b>”Rencana Suksesi”</b> adalah sebagaimana yang diatur lebih lanjut di dalam Pasal 11.",
          },
          {
            tag: "1.1.31",
            content: "<b>“Tindakan Disiplin”</b> adalah sebagaimana didefinisikan dalam Pasal 8.",
          },
          {
            tag: "1.1.32",
            content:
              "<b>Tanggal Rencana Suksesi</b> adalah tanggal efektifnya Rencana Suksesi yang ditetapkan oleh Perusahaan untuk mengalihkan seluruh anggota Grup Manajer Keagenan Langsung dan/atau  Grup  Manajer  Keagenan  Tidak  Langsung (bila ada) ke <i>Designated Successor</i> atau kepada Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi).",
          },
        ],
      },
      {
        tag: "1.2",
        content:
          "Judul dan sub judul dalam Perjanjian ini hanya untuk memudahkan dan tidak mempengaruhi implementasi atau penafsiran atas Perjanjian ini.",
      },
      {
        tag: "1.3",
        content: "Kecuali ditentukan lain, dalam Perjanjian ini:",
        child: [
          {
            tag: "1.3.1",
            content:
              "Kata dengan bentuk tunggal mencakup juga bentuk jamak, demikian pula sebaliknya.",
          },
          {
            tag: "1.3.2",
            content:
              "Referensi yang menunjuk pada Klausul, Pasal, Ayat, dan Lampiran berarti menunjuk pada klausul, pasal, ayat dan lampiran Perjanjian ini.",
          },
          {
            tag: "1.3.3",
            content:
              "Referensi yang menunjuk kepada suatu orang akan dianggap sebagai referensi terhadap para penerus dan pengganti haknya yang sah.",
          },
        ],
      },
    ],
  },
  {
    tag: "2.",
    content: "Penunjukan Manajer Keagenan",
    content2:
      "Perusahaan dengan ini menunjuk dan memberi wewenang  kepada  Manajer  Keagenan  untuk memberikan  Jasa  di  wilayah  negara  Republik  Indonesia dengan tunduk pada syarat-syarat dan ketentuan-ketentuan dalam Perjanjian ini.",
  },
  {
    tag: "3.",
    content: "Tugas  dan  Tanggung  Jawab  Manajer  Keagenan",
    child: [
      {
        tag: "3.1",
        content:
          "Manajer Keagenan wajib untuk mempergunakan waktu dan perhatiannya untuk melakukan hal-hal di bawah ini dengan baik:",
        child: [
          {
            tag: "3.1.1",
            content:
              "Mencari  dan  mencalonkan  orang-orang  berkebangsaan Indonesia, atau orang-orang yang secara hukum yang berlaku di negara Indonesia berhak untuk bertindak sebagai Agen di Indonesia dan menurut pendapat Manajer Keagenan, merupakan calon yang tepat untuk ditunjuk sebagai Agen. Calon tersebut wajib untuk didaftarkan sebagai Agen sesuai dengan Peraturan Keagenan dan dengan tunduk kepada ketentuan sebagai berikut:",
            child: [
              {
                tag: "3.1.1.1",
                content:
                  "Manajer Keagenan dengan jabatan <i>Agency Director</i> berhak untuk mencari dan mencalonkan orang-orang untuk ditunjuk sebagai Agen atau Manajer Keagenan  dengan  jabatan  <i>Agency  Director</i>,  <i>Associate  Agency  Director</i>, <i>Associate Agency Manager</i> dan/atau Agen.",
              },
              {
                tag: "3.1.1.2",
                content:
                  "Manajer Keagenan dengan jabatan  <i>Associate  Agency  Director</i>  berhak untuk mencari dan mencalonkan orang-orang untuk ditunjuk sebagai Agen atau Manajer Keagenan dengan jabatan <i>Associate Agency Director</i>, <i>Associate Agency Manager</i> dan/atau Agen.",
              },
              {
                tag: "3.1.1.3",
                content:
                  "Manajer Keagenan telah melakukan verifikasi atas seluruh detil informasi yang dirujuk, tertera atau disertakan dalam aplikasi pengajuan agen baru dan bahwa seluruh informasi tersebut adalah benar, lengkap dan akurat; dan",
              },
              {
                tag: "3.1.1.4",
                content:
                  "Dokumen-dokumen pendukung yang disertakan dalam aplikasi pengajuan agen baru tersebut adalah merupakan dokumen asli, atau bilamana dalam bentuk fotokopi/digital maka fotokopi/digital tersebut memuat data-data yang sama dengan dokumen aslinya dan tanda tangan yang tertera dalam aplikasi  dan  dokumen-dokumen  tersebut adalah tanda tangan asli calon agen baru.",
              },
            ],
          },
          {
            tag: "3.1.2",
            content:
              "Mengelola dan mengawasi anggota dari unit produksinya baik langsung maupun tidak langsung (<b>“Grup Manajer Keagenan”</b>), dan  memastikan  bahwa  setiap  anggota  Grup  Manajer Keagenan mematuhi syarat dan ketentuan  dalam  Perjanjian  Keagenan,  Perjanjian  Manajer  Keagenan,  pedoman,  perintah,  Peraturan  Keagenan  dan/atau peraturan perundang-undangan yang berlaku dari waktu ke waktu;",
          },
          {
            tag: "3.1.3",
            content:
              "Melatih dan mengembangkan anggota Grup Manajer  Keagenan  sehingga  dapat  melaksanakan  kewajiban  dan  tanggung  jawabnya terhadap Perusahaan berdasarkan Perjanjian Keagenan, Perjanjian Manajer Keagenan, pedoman, perintah, Peraturan Keagenan dan/atau peraturan perundang-undangan, dan meningkatkan mutu pelayanan dan produksi bisnis baru Grup Manajer Keagenan;",
          },
          {
            tag: "3.1.4",
            content:
              "Jika  diperlukan,  merekomendasikan pengakhiran  Perjanjian  Keagenan  atau  Perjanjian  Manajer  Keagenan  dari  anggota Grup Manajer Keagenan, dengan  memberikan  alasan  secara  tertulis  kepada  Perusahaan, dengan  ketentuan  bahwa  Perusahaan  mempunyai  hak  mutlak  untuk  menerima maupun  menolak  rekomendasi  Manajer Keagenan; dan",
          },
          {
            tag: "3.1.5",
            content:
              "Melaksanakan tugas, jasa, dan/atau fungsi lain yang  atas  pertimbangan  Perusahaan  ditugaskan oleh Perusahaan dari waktu ke waktu kepada Manajer Keagenan termasuk namun tidak terbatas untuk memasarkan dan menjual Produk Asuransi kepada Nasabah.",
          },
        ],
      },
      {
        tag: "3.2",
        content:
          "Perusahaan  mempunyai  hak  mutlak  untuk menentukan penunjukan, promosi dan/atau demosi atas Manajer Keagenan dan setiap serta seluruh anggota Grup Manajer Keagenan, serta pengakhiran Perjanjian Keagenan Perusahaan dengan anggota Grup Manajer Keagenan.",
      },
      {
        tag: "3.3",
        content:
          "Apabila Manajer Keagenan memberikan aplikasi Produk Asuransi atau dokumen-dokumen lain dalam rangka penjualan Produk Asuransi untuk  Nasabah kepada Perusahaan, maka Manajer Keagenan akan dianggap menyatakan dan menjamin Perusahaan bahwa:",
        child: [
          {
            tag: "3.3.1",
            content:
              "Manajer Keagenan telah melakukan verifikasi atas seluruh detil informasi yang dirujuk, tertera atau disertakan dalam aplikasi Produk Asuransi Nasabah dan bahwa seluruh informasi tersebut adalah benar, lengkap dan akurat; dan ",
          },
          {
            tag: "3.3.2",
            content:
              "Dokumen-dokumen  pendukung  yang disertakan dalam aplikasi Produk Asuransi Nasabah tersebut adalah merupakan dokumen asli, atau bilamana dalam bentuk fotokopi/digital maka fotokopi/digital tersebut memuat data-data yang sama dengan dokumen aslinya dan tanda tangan yang tertera dalam aplikasi dan dokumen-dokumen tersebut adalah tanda tangan asli Nasabah.",
          },
        ],
      },
      {
        tag: "3.4",
        content: "Dalam memberikan Jasa, Manajer Keagenan wajib untuk setiap saat: ",
        child: [
          {
            tag: "3.4.1",
            content:
              "Bertindak jujur dan penuh integritas dengan menyampaikan identitas sebagai wakil yang sah dari Perusahaan dengan menunjukkan Lisensi Keagenan yang masih berlaku, baik lisensi Keagenan yang dikeluarkan oleh Asosiasi Asuransi Jiwa Indonesia (AAJI)",
          },
          {
            tag: "3.4.2",
            content:
              "Bertindak dengan niat baik dan meletakkan kepentingan Nasabah di atas kepentingan Manajer Keagenan; ",
          },
          {
            tag: "3.4.3",
            content:
              "Memberikan informasi yang benar dan akurat mengenai Produk Asuransi termasuk informasi penting terkait dengan biaya-biaya, serta syarat dan ketentuan Polis kepada Nasabah;",
          },
          {
            tag: "3.4.4",
            content:
              "Mempertahankan agar polis-polis Produk Asuransi dalam Grup Manajer Keagenan tetap berlaku (menjaga persistensi Grup Manajer Keagenan);",
          },
          {
            tag: "3.4.5",
            content:
              "Memberikan informasi yang benar dan akurat mengenai syarat dan ketentuan sebagai tenaga pemasar pada Perusahaan pada calon anggota Grup Manajer Keagenan;",
          },
          {
            tag: "3.4.6",
            content:
              "Meneruskan setiap dan seluruh keluhan  (<i>complaint</i>)  tertulis  Nasabah  kepada Perusahaan selambat-lambatnya dalam jangka waktu  2 x 24 jam terhitung sejak Manajer Keagenan  atau  anggota  Grup  Manajer Keagenan menerima keluhan tersebut; dan",
          },
          {
            tag: "3.4.6",
            content:
              "Memastikan  untuk  menggunakan  materi  pemasaran dan ilustrasi yang terbaru yang dikeluarkan oleh Perusahaan. ",
          },
        ],
      },
      {
        tag: "3.5",
        content: "Manajer Keagenan dilarang untuk:",
        child: [
          {
            tag: "3.5.1",
            content:
              "Memberikan informasi dan/atau pernyataan yang salah atau menyesatkan mengenai Produk  Asuransi,  Perusahaan,  perintah,  pedoman atau strategi yang ditetapkan oleh Perusahaan;",
          },
          {
            tag: "3.5.2",
            content:
              "Membuat perjanjian (dalam bentuk apa pun) dengan pihak ketiga atas nama Perusahaan;",
          },
          {
            tag: "3.5.3",
            content: "Melakukan Jasa di luar wilayah Republik Indonesia;",
          },
          {
            tag: "3.5.4",
            content:
              "Membuat atau melakukan perubahan terhadap ilustrasi Produk Asuransi yang telah ditentukan oleh Perusahaan, untuk menciptakan suatu ekspektasi yang tidak masuk akal;",
          },
          {
            tag: "3.5.5",
            content:
              "Tanpa persetujuan tertulis sebelumnya dari Perusahaan (i) membuat, menerbitkan, membagikan atau mengedarkan iklan-iklan,  surat–surat,  brosur penjualan,  bahan pemasaran, barang cetakan atau tulisan, (ii) mengirimkan atau menyediakan suatu berita atau informasi, atau (iii) memasang iklan dalam suatu penerbitan baik cetak maupun elektronik mengenai  Produk  Asuransi  dan/atau  Perusahaan, baik atas nama sendiri maupun atas nama atau mengikutsertakan nama Perusahaan;",
          },
          {
            tag: "3.5.6",
            content:
              "Menggunakan barang, materi, atau fasilitas milik atau yang disediakan oleh Perusahaan untuk suatu maksud selain pemberian Jasa; dan",
          },
          {
            tag: "3.5.7",
            content:
              "Membayarkan premi nasabah terlebih dahulu dan/atau membiayai premi nasabah baik secara tunai, <i>cheque</i>/Bilyet Giro (BG), transfer atau dengan cara pembayaran lainnya, termasuk juga membayarkan premi nasabah dengan menggunakan kartu kredit Manajer Keagenan.",
          },
          {
            tag: "3.5.8",
            content:
              "Secara langsung atau tidak langsung, dan dalam kapasitas apa pun, baik atas namanya sendiri maupun sebagai Manajer Keagenan, terlibat atau melakukan pekerjaan/tugas rangkap dalam setiap kegiatan bisnis asuransi jiwa, baik secara non syariah maupun syariah, atau bisnis lain yang berkompetisi dengan Perusahaan  baik  secara  legal  atau  illegal  atau  mengganggu  dan/atau  merugikan  bisnis  Perusahaan  baik  dengan  menggunakan  maupun  tidak  menggunakan  jaringan  pemasaran  keagenan  dan/atau  nasabah  Perusahaan.",
          },
          {
            tag: "3.5.9",
            content:
              "Mengizinkan anggota Grup Manajer Keagenan untuk terlibat dalam kegiatan sebagaimana dimaksud pada pasal 3.5.8 di atas serta mewakili dan/atau menjual produk asuransi jiwa milik perusahaan asuransi lainnya selain dari Perusahaan.",
          },
        ],
      },
      {
        tag: "3.6",
        content:
          "Dalam melakukan Jasa, Manajer Keagenan wajib untuk setiap saat dan dalam segala hal patuh dan tunduk terhadap:",
        child: [
          {
            tag: "3.6.1",
            content:
              "Setiap dan seluruh strategi, pedoman, perintah dan prosedur yang ditetapkan oleh Perusahaan dari waktu ke waktu sehubungan dengan kinerja Manajer Keagenan;",
          },
          {
            tag: "3.6.2",
            content:
              "Peraturan  Keagenan,  Peraturan  AAJI  dan  berpartisipasi  dalam  setiap  pelatihan,  sosialisasi produk dan program-program kepatuhan (baik diadakan oleh Perusahaan maupun pihak lain) yang disyaratkan oleh Perusahaan; dan",
          },
          {
            tag: "3.6.3",
            content:
              "Seluruh peraturan dan perundang-undangan yang berlaku terhadap Manajer Keagenan, dan wajib memastikan bahwa Jasa dilakukan dalam cara yang tidak (i) melanggar peraturan dan perundang-undangan  yang  berlaku  di  Indonesia atau (ii) yang menurut pendapat  Perusahaan  dapat  merusak  reputasi  Perusahaan.",
          },
        ],
      },
    ],
  },
  {
    tag: "4.",
    content: "<b><i>Overriding</i></b> Manajer Keagenan",
    child: [
      {
        tag: "4.1",
        content:
          "Dengan  mempertimbangkan  kinerja  Manajer Keagenan dalam melakukan Jasa, dan selama masa  berlakunya  Perjanjian  ini,  Perusahaan  akan  memberikan <i>Overriding</i> kepada Manajer Keagenan atas Produk Asuransi yang berhasil dijual atau ditutup, dengan ketentuan bahwa penjualan atau penutupan tersebut telah dilakukan oleh anggota Grup Manajer Keagenan sesuai dengan syarat dan ketentuan dalam Perjanjian Keagenan, Peraturan Keagenan dan Kode Etik Keagenan.",
      },
      {
        tag: "4.2",
        content:
          "<i>Overriding</i> yang berhak diterima Manajer Keagenan akan dihitung berdasarkan syarat dan ketentuan dalam Ketentuan <i>Overriding</i>, dan ketentuan lain yang ditentukan oleh Perusahaan dari waktu ke waktu.",
      },
      {
        tag: "4.3",
        content:
          "Dalam hal terjadi perbedaan perhitungan <i>Overriding</i> antara Manajer Keagenan dan Perusahaan, maka perhitungan yang dilakukan oleh Perusahaan akan berlaku.",
      },
      {
        tag: "4.4",
        content:
          "Selain sebagaimana telah diatur dengan jelas dalam Perjanjian ini, Manajer Keagenan tidak berhak atas remunerasi, pembayaran, penggantian, ganti rugi atau kompensasi dari Perusahaan sehubungan dengan  pelaksanaan  Perjanjian  ini.  Untuk menghindarkan keragu-raguan, Manajer Keagenan wajib untuk membayar dan bertanggung jawab atas segala biaya, pengeluaran, termasuk namun tidak terbatas pada biaya korespondensi, akomodasi, dan biaya-biaya lain dalam bentuk apapun sehubungan dengan atau yang diperlukan oleh Manajer Keagenan untuk melakukan Jasa.",
      },
      {
        tag: "4.5",
        content:
          "Dalam hal Perusahaan mengembalikan premi kepada Nasabah (dengan sebab apa pun), Manajer Keagenan wajib untuk mengembalikan setiap <i>Overriding</i>, insentif, kompensasi dan pendapatan lainnya dalam  bentuk  apapun  yang  telah  diterima  kepada Perusahaan sehubungan dengan pengembalian premi tersebut dan untuk itu Perusahaan juga berhak untuk melakukan  pemotongan  langsung  terhadap  <i>Overriding</i>, insentif, kompensasi dan pendapatan lainnya dalam bentuk apapun  tersebut (<i>clawback</i>).",
      },
      {
        tag: "4.6",
        content:
          "Perusahaan berhak untuk menahan, mengubah, atau tidak membayarkan <i>Overriding</i>, komisi, insentif, kompensasi dan/atau pendapatan lainnya dalam bentuk apapun berdasarkan Perjanjian ini, lampiran-lampirannya, dan Peraturan Keagenan apabila:",
        content2:
          "dan  dalam  hal  demikian  Manajer  Keagenan melepaskan seluruh haknya untuk mengajukan tuntutan atau gugatan apa pun terhadap Perusahaan sehubungan dengan kerugian Manajer Keagenan akibat pelaksanaan Pasal 4.6 ini.",
        child: [
          {
            tag: "4.6.1",
            content:
              "menurut pendapat Perusahaan, hal tersebut diperlukan  untuk  mematuhi  peraturan  perundangan yang berlaku di Indonesia maupun Peraturan Keagenan dan Perjanjian; dan/atau",
          },
          {
            tag: "4.6.2",
            content: "Manajer Keagenan tidak memenuhi ketentuan Pasal 10.5",
          },
        ],
      },
      {
        tag: "4.7",
        content:
          "Perusahaan berhak untuk meminta Manajer Keagenan untuk mengembalikan jumlah yang sudah dibayarkan dengan cara yang tidak sesuai dengan Pasal 4.1, Pasal 4.2 dan Pasal 4.3.",
      },
      {
        tag: "4.8",
        content:
          "Dalam hal Manajer Keaganan memiliki Perjanjian Manajer Keagenan dengan Prudential Syariah, maka Perusahaan berhak untuk menahan, melakukan pemotongan langsung, mengubah atau tidak membayarkan  komisi,  <i>Overriding</i>,  insentif,  kompensasi dan/atau pendapatan lainnya dalam bentuk apapun berdasarkan Perjanjian ini atau Peraturan Keagenan apabila terdapat kewajiban dan/atau piutang Manajer Keagenan yang telah jatuh tempo dan dapat ditagih kepada Prudential Syariah.",
      },
      {
        tag: "4.9",
        content: "Untuk maksud-maksud di bawah ini:",
        content2:
          'Manajer Keagenan dengan ini memberikan kuasa yang tidak dapat dicabut kembali kepada Perusahaan untuk memotong <i>Overriding</i>, insentif, kompensasi dan/atau pendapatan lain berdasarkan Perjanjian ini ("<i>Overriding</i>"),  lampiran-lampirannya,  dan/atau  Peraturan  Keagenan.  Dalam  hal  pemotongan  <i>Overriding</i>,  insentif,  kompensasi  dan/atau pendapatan lain tidak cukup untuk mengembalikan  <i>Overriding</i>,  insentif,  kompensasi  dan/atau pendapatan lain dalam bentuk apapun tersebut, maka Perusahaan akan memberitahu Manajer Keagenan secara tertulis dan Manajer Keagenan wajib dengan segera, namun tidak lebih dari 2 (dua) hari kerja setelah pemberitahuan tertulis dari Perusahaan, membayar jumlah yang diminta tersebut kepada Perusahaan.',
        child: [
          {
            tag: "4.9.1",
            content:
              "Perusahaan mempunyai piutang yang telah jatuh tempo dan dapat ditagih kepada Manajer Keagenan dan/atau anggota Grup Manajer Keagenan;",
          },
          {
            tag: "4.9.2",
            content: "Kondisi sebagaimana diatur dalam Pasal 4.5 dan Pasal 4.6 terjadi;",
          },
          {
            tag: "4.9.3",
            content: "Kondisi sebagaimana diatur dalam Pasal 4.7;",
          },
          {
            tag: "4.9.4",
            content: "Kondisi sebagaimana diatur dalam Pasal 4.8 terjadi;",
          },
          {
            tag: "4.9.5",
            content: "Kondisi sebagaimana diatur dalam Pasal 9.2 terjadi; dan/atau",
          },
          {
            tag: "4.9.6",
            content: "Kondisi sebagaimana diatur dalam Pasal 9.3 terjadi,",
          },
        ],
      },
    ],
  },
  {
    tag: "5.",
    content: "Pernyataan Dan Jaminan",
    subContent: "Manajer Keagenan dengan ini menyatakan dan menjamin bahwa:",
    child: [
      {
        tag: "5.1",
        content:
          "Manajer  Keagenan  berwenang  membuat,  melangsungkan dan melaksanakan Perjanjian ini dan dokumen-dokumen  lain  sehubungan  dengan Perjanjian ini, serta telah melaksanakan semua tindakan dan persyaratan yang disyaratkan untuk sahnya  pembuatan,  penandatanganan  dan pelaksanaan Perjanjian ini dan dokumen-dokumen lain sehubungan dengan Perjanjian. ",
      },
      {
        tag: "5.2",
        content:
          "Manajer Keagenan menyetujui dan memberikan izin kepada  Perusahaan  untuk  mengumpulkan,  menggunakan, mengelola, mengirimkan ataupun mengungkapkan sebagian ataupun keseluruhan informasi milik Manajer Keagenan (meliputi tetapi tidak terbatas kepada data pribadi Manajer Keagenan seperti Nama, Alamat, Nomor Identitas, Nomor Telepon, maupun berbagai bentuk informasi lainnya yang berkaitan dengan Manajer Keagenan), termasuk memberikannya kepada pihak ketiga yang berafiliasi dengan Perusahaan sepanjang dianggap perlu ataupun untuk memenuhi tujuan lainnya yang dapat meliputi tetapi tidak terbatas kepada kegiatan peragenan, pemasaran asuransi, penyediaan layanan kepada Nasabah, ataupun apabila dibutuhkan oleh peraturan perundang-undangan yang berlaku dan lain-lain.",
      },
      {
        tag: "5.3",
        content:
          "Perjanjian ini dan dokumen-dokumen terkait lainnya  adalah  sah,  berlaku  dan  mengikat  sah  dan  menimbulkan kewajiban hukum terhadap orang atau pihak yang membuat, menandatangani, menyerahkan atau menerbitkan dokumen atau perjanjian tersebut, sesuai dengan syarat dan ketentuan yang tercantum di dalamnya.",
      },
    ],
  },
  {
    tag: "6.",
    content: "Evaluasi Manajer Keagenan",
    content2:
      'Perusahaan berhak untuk melakukan evaluasi atas kinerja Manajer Keagenan (“<b>Evaluasi</b>"), sesuai dengan ketentuan validasi sebagaimana diatur dalam Lampiran II Perjanjian ini yang sewaktu-waktu dapat diubah mengikuti ketentuan yang ditetapkan oleh Perusahaan melalui Peraturan Keagenan. Berdasarkan hasil  Evaluasi,  atas  kebijakan  Perusahaan,  Perusahaan dapat melakukan promosi atau demosi terhadap Manajer Keagenan, atau mengakhiri Perjanjian berdasarkan Pasal 10.3.',
  },
  {
    tag: "7.",
    content: "Pemeriksaan Manajer Keagenan",
    content2:
      "Perusahaan  berhak  setiap  saat  melakukan pemeriksaan atas seluruh kegiatan yang dilakukan oleh  Manajer  Keagenan  dengan  atau  tanpa pemberitahuan terlebih dahulu. Selama pemeriksaan dan atas permintaan Perusahaan dan/atau orang yang ditunjuk  oleh  Perusahaan  untuk  melakukan  pemeriksaaan,  Manajer  Keagenan  wajib  untuk memberikan seluruh dokumen dan informasi yang dimilikinya dengan benar dan secara terperinci kepada Perusahaan.",
  },
  {
    tag: "8.",
    content: "Tindakan Disiplin dan Penangguhan",
    child: [
      {
        tag: "8.1",
        content:
          "Dalam hal Perusahaan menemukan bahwa Manajer Keagenan  telah  melakukan  Pelanggaran  (sebagaimana didefinisikan dalam Pasal 9.3), maka Perusahaan dapat, atas kebijakan Perusahaan, memberikan  Tindakan  Disiplin  (sebagaimana  didefinisikan dalam Pasal 8.2) kepada Manajer Keagenan, atau tindakan-tindakan lain yang dianggap perlu oleh Perusahaan.",
      },
      {
        tag: "8.2",
        content:
          "Tindakan disiplin yang dapat dikenakan kepada Manajer Keagenan oleh Perusahaan berdasarkan Perjanjian ini (tidak wajib dikenakan secara berurutan) adalah (i) peringatan tertulis, (ii) Penangguhan, (iii)  pengakhiran  Perjanjian  Keagenan  atau  (iv) pencantuman nama Agen ke dalam Daftar Tenaga Pemasar Bermasalah AAJI (“<b>Tindakan Disiplin</b>)",
      },
      {
        tag: "8.3",
        content:
          "Dalam hal Manajer Keagenan dikenakan Tindakan Disiplin yang berupa Penangguhan, maka:",
        child: [
          {
            tag: "8.3.1",
            content:
              "Perusahaan dapat menangguhkan sebagian atau seluruh hak Manajer Keagenan untuk mempromosikan, memasarkan dan menjual Produk Asuransi kepada Nasabah; dan/atau hak Manajer Keagenan untuk menerima <i>Overriding</i> dan Komisi; dan/atau menerima kompensasi  dan/atau  pendapatan  lain  berdasarkan  Perjanjian  ini,  Peraturan Keagenan, dan lampiran-lampirannya; dan/atau menerima hak-hak lainnya (perjalanan insentif dan insentif lainnya)  sesuai dengan keputusan dan  batas  waktu  yang  ditentukan  oleh Perusahaan; dan",
          },
          {
            tag: "8.3.2",
            content:
              "Manajer Keagenan wajib untuk mereferensikan Manajer Keagenan di atas-nya langsung untuk setiap pertanyaan mengenai Jasa dari setiap Nasabah; serta",
          },
          {
            tag: "8.3.3",
            content:
              "Manajer Keagenan tetap wajib untuk mematuhi setiap dan seluruh syarat dan ketentuan dalam Perjanjian ini.",
          },
        ],
      },
      {
        tag: "8.4",
        content:
          "Dalam hal terdapat keluhan (<i>complaint</i>) terhadap Perusahaan yang diduga disebabkan oleh kelalaian atau kesalahan Manajer Keagenan dalam melakukan Jasa, Perusahaan dapat meminta Manajer Keagenan untuk membantu Perusahaan dalam melakukan investigasi dan Manajer Keagenan wajib untuk membantu investigasi serta memberikan seluruh informasi yang dimilikinya dengan benar kepada Perusahaan. Selama masa investigasi, Perusahaan dapat, atas kebijakan Perusahaan, melakukan Tindakan Disiplin kepada Manajer Keagenan dan/atau menahan Komisi, <i>Overriding</i> insentif, kompensasi dan/atau pendapatan lain dalam bentuk apapun serta hak lainnya pada Perusahaan.",
      },
    ],
  },
  {
    tag: "9.",
    content: "Ganti Kerugian",
    child: [
      {
        tag: "9.1",
        content:
          "Perusahaan berhak untuk menyelesaikan setiap keluhan (<i>complaint</i>) dan/atau Kerugian Nasabah sesuai dengan syarat dan ketentuan yang dianggap baik menurut kebijakan Perusahaan tanpa kewajiban untuk memberitahu atau berkonsultasi terlebih dahulu dengan Manajer Keagenan.",
      },
      {
        tag: "9.2",
        content:
          "Apabila Kerugian sebagaimana tersebut dalam Pasal 9.1 diakibatkan oleh (i) Pelanggaran (sebagaimana didefinisikan dalam Pasal 9.3) yang dilakukan oleh Manajer Keagenan, dan/atau (ii) pelanggaran Perjanjian Keagenan oleh anggota Grup Manajer Keagenan dan Kerugian tersebut tidak dapat diganti oleh anggota Grup Manajer Keagenan tersebut dalam jangka waktu 14 (empat belas) hari, maka Manajer Keagenan berkewajiban untuk mengganti Kerugian kepada Perusahaan.",
      },
      {
        tag: "9.3",
        content:
          "Manajer Keagenan wajib untuk mengganti segala Kerugian yang diderita oleh Perusahaan dan/atau Nasabah sebagai akibat dari salah satu dari hal-hal di bawah ini (“<b>Pelanggaran</b>”):",
        child: [
          {
            tag: "9.3.1",
            content:
              "Kelalaian atau kesalahan Manajer Keagenan dalam memenuhi kewajiban dan tanggung  jawab  Manajer  Keagenan  sebagaimana  diuraikan dalam Pasal 3, dan/atau  kelalaian  atau  kesalahan  anggota  Grup  Manajer  Keagenan dalam melaksanakan kewajibannya berdasarkan Perjanjian Keagenan dan/atau Perjanjian Manajer Keagenan (yang mana yang berlaku);",
          },
          {
            tag: "9.3.2",
            content:
              "Pelanggaran yang dilakukan oleh Manajer Keagenan atas setiap atau seluruh ketentuan dalam Perjanjian ini, lampiran-lampirannya, strategi, pedoman, perintah, Peraturan Keagenan dan/atau peraturan perundang-undangan yang berlaku, baik disengaja maupun tidak disengaja dan dengan cara apa pun;",
          },
          {
            tag: "9.3.3",
            content:
              "Pelanggaran yang dilakukan oleh anggota Grup Manajer Keagenan atas setiap atau seluruh ketentuan  dalam  Perjanjian  Keagenan,  Perjanjian Manajer Keagenan dan lampiran-lampirannya, strategi, pedoman, perintah,  Peraturan  Keagenan  dan/atau  peraturan  perundang-undangan  yang  berlaku,  baik  disengaja  maupun tidak disengaja dan dengan cara apa pun, dan Kerugian tersebut tidak dapat diganti oleh anggota Grup Manajer Keagenan tersebut dalam jangka waktu 14 (empat belas) hari; atau",
          },
          {
            tag: "9.3.4",
            content:
              "Pernyataan dan/atau jaminan yang diberikan oleh Manajer Keagenan dalam Perjanjian ini ternyata atau terbukti tidak benar atau tidak sesuai dengan kenyataan sebenarnya.",
          },
        ],
      },
      {
        tag: "9.4",
        content:
          "Manajer Keagenan dengan ini membebaskan dan melepaskan Perusahaan, Pemegang Saham, para anggota Direksi, Komisaris dan karyawannya dari segala perlawanan, tuntutan, gugatan dalam bentuk apapun, dan permintaan ganti rugi dari pihak ketiga yang timbul sehubungan dengan pelaksanaan Jasa dan setiap pelanggaran yang dilakukan oleh Manajer Keagenan atas syarat dan ketentuan yang diatur di dalam Perjanjian ini, maupun sehubungan dengan pemotongan <i>Overriding</i>, komisi insentif, kompensasi dan/atau pendapatan lain dari Manajer Keagenan sebagaimana diatur dalam Pasal 4.9.",
      },
    ],
  },
  {
    tag: "10.",
    content: "Jangka Waktu dan Pengakhiran Perjanjian",
    child: [
      {
        tag: "10.1",
        content:
          "Perjanjian ini mulai berlaku terhitung sejak tanggal Perusahaan membubuhkan tanda tangannya pada Perjanjian ini, untuk suatu waktu yang tidak terbatas, kecuali diakhiri lebih awal oleh salah satu Pihak berdasarkan Pasal ini.",
      },
      {
        tag: "10.2",
        content:
          "Salah satu Pihak berhak untuk mengakhiri Perjanjian ini setiap saat, dengan memberikan pemberitahuan tertulis 14 (empat belas) hari sebelumnya kepada Pihak lainnya, kecuali ditentukan lain dalam Pasal 10.4, tidak ada satu Pihak pun yang diwajibkan untuk membayar kompensasi dalam bentuk apapun kepada Pihak lainnya. Dalam hal Manajer Keagenan ingin mengakhiri Perjanjian ini, maka Manajer Keagenan wajib untuk memberikan alasan pengakhiran Perjanjian, dan pengakhiran tersebut akan berlaku efektif pada tanggal yang dicantumkan di dalam surat konfirmasi pengakhiran dari Perusahaan.",
      },
      {
        tag: "10.3",
        content:
          "Perusahaan berhak untuk mengakhiri Perjanjian tanpa pemberitahuan  sebelumnya  kepada  Manajer Keagenan, dalam hal salah satu dari hal-hal berikut terjadi:",
        child: [
          {
            tag: "10.3.1",
            content:
              "Manajer Keagenan meninggal dunia atau menderita Cacat Total dan Tetap sebagaimana didefinisikan dalam Pasal 1.1.4;",
          },
          {
            tag: "10.3.2",
            content:
              "Manajer Keagenan dinyatakan dalam keadaan pailit atau diberikan penundaan kewajiban pembayaran hutang;",
          },
          {
            tag: "10.3.3",
            content:
              "Manajer Keagenan terlibat atau diduga terlibat dalam perkara baik pidana maupun perdata;",
          },
          {
            tag: "10.3.4",
            content:
              "Perusahaan melakukan demosi terhadap Manajer Keagenan sehingga jabatan Manajer Keagenan menjadi Agen;",
          },
          {
            tag: "10.3.5",
            content:
              "Manajer Keagenan berada dalam keadaan Pelanggaran sebagaimana diatur dalam Pasal 9.3;",
          },
          {
            tag: "10.3.6",
            content:
              "Dengan ditandatanganinya Perjanjian Manajer  Keagenan  yang  baru  oleh  Para  Pihak, sehubungan dengan pengalihan hak dan kewajiban Manajer Keagenan kepada suatu badan hukum; atau",
          },
          {
            tag: "10.3.7",
            content:
              "Perjanjian Keagenan berakhir sesuai dengan syarat-syarat dan ketentuan-ketentuan yang termuat di dalamnya.",
          },
        ],
      },
      {
        tag: "10.4",
        content: "Dalam hal Perjanjian berakhir:",
        child: [
          {
            tag: "10.4.1",
            content:
              "Manajer Keagenan wajib untuk, dalam jangka waktu selambat-lambatnya 7 (tujuh) hari kerja terhitung sejak tanggal efektif pengakhiran Perjanjian, mengembalikan setiap dan seluruh dokumen-dokumen dan barang-barang milik Perusahaan, baik dalam format elektronik maupun cetak.",
          },
          {
            tag: "10.4.2",
            content:
              "Para Pihak wajib menyelesaikan setiap dan segala kewajiban berdasarkan Perjanjian ini dan lampiran-lampirannya, serta perjanjian lain yang dibuat oleh dan antara Manajer Keagenan dan Perusahaan, dan Peraturan Keagenan Perusahaan, dalam jangka waktu selambat-lambatnya 7 (tujuh) hari kerja terhitung sejak tanggal pengakhiran Perjanjian.",
          },
          {
            tag: "10.4.3",
            content:
              "Manajer  Keagenan  tidak  berhak  untuk menuntut atau menerima <i>Overriding</i>, insentif, kompensasi atau pendapatan lain berdasarkan Perjanjian ini, lampiran-lampirannya, dan Peraturan Keagenan, terhitung setelah tanggal efektif pengakhiran Perjanjian ini (selain daripada jumlah yang telah jatuh tempo dan dapat dibayarkan kepada Manajer Keagenan sebelum tanggal efektif berakhirnya Perjanjian ini).",
          },
          {
            tag: "10.4.4",
            content:
              "Pasal 9, Pasal 11, Pasal 10.5, Pasal 12.1, Pasal 13 dan Pasal 14 akan tetap berlaku dan mengikat Para Pihak.",
          },
        ],
      },
      {
        tag: "10.5",
        content:
          "Manajer Keagenan wajib untuk setiap saat, atas permintaan Perusahaan (walaupun Perjanjian telah berakhir), hadir di kantor Perusahaan dan/atau memberikan seluruh informasi yang dimilikinya dengan benar kepada Perusahaan, atau menghadiri setiap persidangan atau panggilan sebagai saksi, untuk memberikan bukti, informasi mengenai Nasabah, Jasa, atau Perjanjian ini.",
      },
      {
        tag: "10.6",
        content:
          "Dalam hal pengakhiran Perjanjian ini, Para Pihak mengesampingkan berlakunya Pasal 1266 Kitab Undang-Undang  Hukum  Perdata  sepanjang diperlukannya putusan pengadilan bagi pengakhiran Perjanjian ini.",
      },
    ],
  },
  {
    tag: "11.",
    content: "Rencana Suksesi",
    child: [
      {
        tag: "11.1",
        content:
          "Selama  masa  berlakunya  Perjanjian  Manajer  Keagenan ini, Manajer Keagenan dengan jabatan <i>Agency Director</i> akan melaksanakan Rencana Suksesi sebagaimana diatur di dalam Pasal 11.2, Pasal 11.3, Pasal 11.4, Pasal 11.5 dan Pasal 11.6 dan tunduk kepada segala persyaratan yang ditetapkan oleh Perusahaan.",
        subContent:
          "Ketentuan mengenai Rencana Suksesi ini hanya berlaku bagi Manajer Keagenan dengan jabatan <i>Agency Director</i> dan berlaku efektif pada Tanggal Rencana Suksesi dan hanya apabila <i>Agency Director</i> mengalami Cacat Total dan Tetap atau meninggal dunia.",
      },
      {
        tag: "11.2",
        content: "<b><i>Agency Director</i> yang hanya Memiliki GMKL di Bawahnya.</b>",
        child: [
          {
            tag: "11.2.1",
            content: "<b><i>Agency Director</i> menderita Cacat Total dan Tetap</b>",
            subContent:
              "Pada  Tanggal  Rencana  Suksesi,  seluruh  anggota  GMKL  akan  dialihkan  kepada <i>Designated Successor</i> atau kepada Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi), di mana hal-hal berikut ini dapat berlaku.",
            subContent2: "ORD akan diberikan kepada pihak-pihak berikut dengan ketentuan:",
            child: [
              {
                tag: "a.",
                content:
                  "<b>untuk 7 (tujuh) tahun pertama setelah Tanggal Rencana Suksesi (”7 Tahun Pertama”)</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk  <i>Agency  Director</i>  dan/atau  pihak  yang  ditunjuk  secara  sah  (terbatas  pada  pihak-pihak  yang  memiliki  hubungan  kekeluargaan dengan <i>Agency Director</i>) oleh <i>Agency Director</i>.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk <i>Designated  Successor</i>  atau  kepada  Pengganti <i>Agency  Director</i> (bila  <i>Designated  Successor</i>  tidak  ada  pada  Tanggal Rencana Suksesi).",
                  },
                ],
              },
              {
                tag: "b.",
                content: "<b>untuk masa berikutnya setelah 7 Tahun Pertama</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 100% ORD",
                    content:
                      "untuk  <i>Designated Successor</i>  atau  kepada  Pengganti <i>Agency  Director</i> (bila  <i>Designated  Successor</i> tidak ada pada Tanggal Rencana Suksesi).",
                  },
                ],
              },
            ],
          },
          {
            tag: "11.2.2",
            content: "<b><i>Agency Director</i> meninggal dunia</b>",
            subContent:
              "Pada Tanggal Rencana Suksesi, seluruh anggota  GMKL  akan  dialihkan  kepada <i>Designated Successor</i> atau kepada Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi), di mana hal-hal berikut ini dapat berlaku.",
            subContent2: "ORD  akan  diberikan  kepada  pihak-pihak  berikut dengan ketentuan:",
            child: [
              {
                tag: "a. ",
                content:
                  "<b>untuk 7 (tujuh) tahun pertama setelah Tanggal Rencana Suksesi di mana <i>Agency Director</i> telah meninggal dunia (”7 Tahun Pertama”)</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk  seorang  ahli waris  yang  telah  ditunjuk  secara  sah  oleh  seluruh  ahli  waris  <i>Agency  Director</i>  berdasarkan  penetapan  pengadilan.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk  <i>Designated  Successor</i>  atau  kepada  Pengganti <i>Agency  Director</i> (bila  <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi).",
                  },
                ],
              },
              {
                tag: "b. ",
                content: "<b>untuk masa berikutnya setelah 7 Tahun Pertama</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 100% ORD",
                    content:
                      "untuk  <i>Designated  Successor</i>  atau  kepada  Pengganti <i>Agency  Director</i>  (bila <i>Designated Successor</i> tidak ada pada Tanggal  Rencana Suksesi).",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        tag: "11.3",
        content: "<b><i>Agency Director</i> yang Memiliki GMKL dan GMKTL</b>",
        child: [
          {
            tag: "11.3.1",
            content: "<b><i>Agency Director</i> menderita Cacat Total dan Tetap</b>",
            subContent:
              "Pada Tanggal Rencana Suksesi seluruh anggota GMKL dan seluruh anggota GMKTL akan dialihkan kepada <i>Designated Successor</i> atau kepada Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi), di mana hal-hal berikut ini dapat berlaku.",
            subContent2: "ORD dan ORI akan diberikan ke pihak-pihak berikut dengan ketentuan:",
            child: [
              {
                tag: "a.",
                content:
                  "<b>untuk 7 (tujuh) tahun pertama setelah Tanggal Rencana Suksesi (”7 Tahun Pertama”)</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk  <i>Agency  Director</i>  dan/atau  pihak  yang  ditunjuk  secara  sah  (terbatas  pada  pihak-pihak  yang  memiliki  hubungan  kekeluargaan  dengan <i>Agency Director</i>) oleh <i>Agency Director</i>.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk <i>Designated Successor</i>  atau  kepada  Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal  Rencana Suksesi).",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 65% ORI",
                    content:
                      "untuk  <i>Agency  Director</i>  dan/atau  pihak  yang  ditunjuk  secara  sah  (terbatas  pada  pihak-pihak  yang memiliki hubungan kekeluargaan dengan <i>Agency Director</i>) oleh <i>Agency Director</i>.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 35% ORI",
                    content:
                      "untuk <i>Designated Successor</i>  atau  kepada  Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal  Rencana Suksesi).",
                  },
                ],
              },
              {
                tag: "b.",
                content: "<b>untuk masa berikutnya setelah 7 Tahun Pertama</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 100% ORD",
                    content:
                      "untuk  <i>Designated  Successor</i>  atau Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal  Rencana Suksesi).",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 65% ORI",
                    content:
                      "untuk  <i>Agency  Director</i> dan/atau  pihak  yang  ditunjuk  secara  sah  (terbatas  pada  pihak-pihak  yang  memiliki  hubungan  kekeluargaan  dengan  <i>Agency Director</i>) oleh <i>Agency Director</i>.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 35% ORI",
                    content:
                      "untuk  <i>Designated  Successor</i>  atau Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal  Rencana Suksesi).",
                  },
                ],
              },
            ],
          },
          {
            tag: "11.3.2",
            content: "<b><i>Agency Director</i> Meninggal Dunia</b>",
            subContent:
              "Pada  Tanggal  Rencana  Suksesi  seluruh  anggota GMKL dan seluruh anggota GMKTL akan dialihkan kepada <i>Designated Successor</i> atau kepada Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi), di mana hal-hal berikut ini dapat berlaku.",
            subContent2: "ORD dan ORI akan diberikan ke pihak-pihak berikut dengan ketentuan:",
            child: [
              {
                tag: "a.",
                content:
                  "<b>untuk 7 (tujuh) tahun pertama setelah Tanggal Rencana Suksesi di mana <i>Agency Director</i> telah meninggal dunia (”7 Tahun Pertama”)</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk seorang ahli waris yang  telah  ditunjuk  secara  sah  oleh  seluruh  ahli  waris  <i>Agency  Director</i>  berdasarkan penetapan pengadilan.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk <i>Designated  Successor</i>  atau  kepada Pengganti <i>Agency  Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal  Rencana Suksesi).",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 65% ORI",
                    content:
                      "untuk  seorang  ahli  waris yang telah ditunjuk secara sah oleh seluruh  ahli  waris  <i>Agency  Director</i>  berdasarkan penetapan pengadilan.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 35% ORI",
                    content:
                      "untuk <i>Designated Successor</i> atau kepada Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi).",
                  },
                ],
              },
              {
                tag: "b.",
                content: "<b>untuk masa berikutnya setelah 7 Tahun Pertama</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 100% ORD",
                    content:
                      "untuk <i>Designated  Successor</i>  atau  Pengganti <i>Agency  Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi).",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 65% ORI",
                    content:
                      "untuk seorang ahli waris  yang  telah  ditunjuk secara sah oleh seluruh  ahli  waris  <i>Agency  Director</i>  berdasarkan  penetapan pengadilan.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 35% ORI",
                    content:
                      "untuk  <i>Designated  Successor</i> atau  Pengganti <i>Agency Director</i> (bila <i>Designated Successor</i> tidak ada pada Tanggal Rencana Suksesi).",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        tag: "11.4",
        content:
          "Dalam mengajukan permohonan untuk melaksanakan Rencana Suksesi, <i>Agency Director</i> dapat menunjuk <i>Designated Successor</i> sebagai penerima pengalihan seluruh anggota GMKL dan/atau anggota GMKTL beserta <i>Overriding</i> yang melekat padanya. <i>Agency Director</i> dapat melakukan perubahan terhadap penunjukan <i>Designated Successor</i> tersebut sebelum Tanggal Rencana Suksesi. Perubahan penunjukan <i>Designated Successor</i> dilakukan dalam bentuk pemberitahuan tertulis kepada Perusahaan.",
      },
      {
        tag: "11.5",
        content:
          "Sejak Tanggal Rencana Suksesi, maka Perjanjian Keagenan, dan Perjanjian Manajer Keagenan antara <i>Agency Director</i> dengan Perusahaan seluruhnya  menjadi  berakhir.  Kecuali  Perjanjian  Manajer  Keagenan  menyatakan  lain,  seluruh  hak  dan  kewajiban <i>Agency Director</i> berdasarkan perjanjian di muka menjadi tidak berlaku dan tidak mengikat Para Pihak.",
      },
      {
        tag: "11.6",
        content:
          "Ketentuan mengenai pembayaran <i>Overriding</i> terkait dengan Rencana Suksesi sebagaimana diatur di dalam Perjanjian Manajer Keagenan, tetap berlaku dan mengikat meskipun Perjanjian Manajer Keagenan berakhir atau diakhiri.",
      },
      {
        tag: "11.7",
        content:
          "<b>Untuk Manajer Keagenan dengan Jabatan di bawah <i>Agency Director</i> (<i>Associate Agency Director</i>) dan belum dapat mengikuti program Rencana Suksesi maka berlaku ketentuan sebagai berikut:</b>",
        child: [
          {
            tag: "11.7.1",
            content: "<b>Manajer Keagenan menderita Cacat Total dan Tetap</b>",
            subContent:
              "Seluruh anggota Grup Manajer Keagenan akan dialihkan kepada manajer keagenan di atasnya langsung, di mana hal-hal berikut ini akan berlaku:",
            subContent2:
              "<i>Overriding</i> yang dapat diterima oleh Manajer Keagenan sehubungan dengan seluruh produksi anggota Grup Manajer Keagenan baik yang dibuat sebelum maupun setelah adanya ketetapan Perusahaan untuk mengalihkan Anggota Grup Manajer Keagenan berlaku efektif (”OR”) akan diberikan ke pihak-pihak berikut dengan ketentuan:",
            child: [
              {
                tag: "a.",
                content:
                  "<b>untuk 7 (tujuh) tahun pertama setelah adanya ketetapan Perusahaan untuk mengalihkan Anggota Grup Manajer Keagenan berlaku efektif (”7 Tahun Pertama”)</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 50% ORD",
                    content:
                      "untuk Manajer Keagenan  dan/atau  pihak  yang  ditunjuk  secara  sah  (terbatas  pada  pihak-pihak  yang  memiliki  hubungan  kekeluargaan  dengan  Manajer  Keagenan)  oleh  Manajer Keagenan.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 50% OR",
                    content: "untuk manajer keagenan di atasnya langsung.",
                  },
                ],
              },
              {
                tag: "b.",
                content: "<b>untuk masa berikutnya setelah 7 Tahun Pertama</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 100% OR",
                    content: "untuk manajer keagenan di atasnya langsung.",
                  },
                ],
              },
            ],
          },
          {
            tag: "11.7.2",
            content: "<b>Manajer Keagenan Meninggal Dunia</b>",
            subContent:
              "Seluruh anggota Grup Manajer Keagenan akan dialihkan kepada manajer keagenan di atasnya langsung, di mana hal-hal berikut ini dapat berlaku.",
            subContent2: "OR akan diberikan ke pihak-pihak berikut dengan ketentuan:",
            child: [
              {
                tag: "a.",
                content:
                  "<b>untuk 7 (tujuh) tahun pertama setelah Manajer Keagenan meninggal dunia dan adanya ketetapan Perusahaan untuk mengalihkan Anggota Grup Manajer Keagenan  berlaku efektif (”7 Tahun Pertama”)</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 50% OR",
                    content:
                      "untuk seorang ahli waris yang  telah  ditunjuk  secara sah oleh seluruh  ahli  waris  Manajer Keagenan berdasarkan penetapan pengadilan.",
                  },
                  {
                    isPercentContent: true,
                    tag: "- 50% OR",
                    content: "untuk manajer keagenan di atasnya langsung.",
                  },
                ],
              },
              {
                tag: "b.",
                content: "<b>untuk masa berikutnya setelah 7 Tahun Pertama</b>",
                child: [
                  {
                    isPercentContent: true,
                    tag: "- 100% OR",
                    content: "untuk manajer keagenan di atasnya langsung.",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    tag: "12.",
    content: "Pembatasan",
    child: [
      {
        tag: "12.1",
        content:
          "Selama berlakunya Perjanjian ini dan untuk seterusnya setelah Perjanjian ini berakhir, Manajer Keagenan dilarang untuk secara langsung maupun tidak langsung dan dalam kapasitas apapun:",
        child: [
          {
            tag: "12.1.1",
            content:
              "Membujuk atau dengan cara apa pun membuat  Nasabah  menebus  (<i>surrender</i>)  polis  Perusahaan atau membiarkan polis Perusahaan tidak berlaku (<i>lapse</i>); dan",
          },
          {
            tag: "12.1.2",
            content:
              "Membujuk atau dengan cara apapun (i) membuat agen atau karyawan  Perusahaan  mengakhiri  hubungan  keagenan  atau  hubungan kerjanya dengan Perusahaan, atau  (ii)  mempekerjakan  agen  atau  karyawan Perusahaan.",
          },
        ],
      },
    ],
  },
  {
    tag: "13.",
    content: "Kekayaan Intelektual",
    child: [
      {
        child: [
          {
            tag: "13.1",
            content:
              "Setiap Kekayaan Intelektual, termasuk Logo Perusahaan, hanya dapat digunakan oleh Manajer Keagenan semata-mata untuk melaksanakan Jasa sesuai dengan syarat dan ketentuan dalam Perjanjian ini. Para Pihak dengan ini setuju bahwa seluruh Kekayaan Intelektual, termasuk Logo Perusahaan, adalah milik Perusahaan dan/atau afiliasinya.",
          },
          {
            tag: "13.2",
            content:
              "Manajer Keagenan tidak diperkenankan untuk mengubah, mendaftarkan, memodifikasi dan/atau menggunakan Kekayaan Intelektual, termasuk Logo Perusahaan  untuk  maksud  apa  pun,  tanpa persetujuan tertulis terlebih dahulu dari Perusahaan.",
          },
          {
            tag: "13.3",
            content:
              "Manajer Keagenan tidak diperkenankan untuk menggunakan, mengedarkan, mendistribusikan, menggandakan atau memperbanyak, baik secara langsung maupun tidak langsung, setiap kekayaan intelektual yang dimiliki oleh pihak ketiga manapun, termasuk namun tidak terbatas pada setiap hak paten, hak cipta, hak merek, rahasia dagang, hasil karya, desain, metode, teknik, proses, prosedur, ilustrasi, baik terdaftar maupun tidak, baik dalam bentuk cetak, audio atau video (selanjutnya disebut  “Penggunaan  Kekayaan  Intelektual”),  tanpa  mendapatkan persetujuan tertulis terlebih dahulu dari pihak ketiga pemilik kekayaan intelektual tersebut.",
            subContent:
              "Manajer  Keagenan  akan  bertanggung  jawab  sepenuhnya atas segala Penggunaan Kekayaan Intelektual tersebut dan akan membebaskan serta melepaskan Perusahaan, pemegang saham, para anggota direksi, komisaris dan karyawannya dari segala perlawanan, tuntutan, gugatan dalam bentuk apapun dan permintaan ganti rugi dari pihak ketiga yang timbul dari Penggunaan Kekayaan Intelektual tersebut",
            },
        ],
      },

    ],
  },
  {
    tag: "14.",
    content: "Kerahasiaan",
    child: [
      {
        tag: "14.1",
        content: "Manajer Keagenan wajib menjamin bahwa:",
        child: [
          {
            tag: "14.1.1",
            content: "semua Informasi Rahasia harus:",
            child: [
              {
                tag: "(1)",
                content: "digunakan semata-mata untuk maksud sebagaimana yang telah ditentukan",
                isTagNumber: true,
              },
              {
                tag: "(2)",
                content: "diperlakukan dengan tingkat kerahasiaan tinggi",
                isTagNumber: true,
              },
              {
                tag: "(3)",
                content:
                  "tidak digandakan kecuali bila memang benar-benar dibutuhkan untuk keperluan resmi; dan",
                isTagNumber: true,
              },
              {
                tag: "(4)",
                content: "dikembalikan dan/atau dihancurkan sesuai dengan petunjuk dari Perusahaan",
                isTagNumber: true,
              },
            ],
          },
          {
            tag: "14.1.2",
            content:
              "pengamanan dan pengawasan yang tepat dilakukan untuk melindungi dan menjaga semua Informasi Rahasia Perusahaan dari penggunaan dan/atau pengungkapan ke pihak ketiga yang tidak sah. Pengamanan dan pengawasan tersebut termasuk tetapi tidak terbatas pada: i) dalam hal Informasi Rahasia berbentuk dokumen, mengamankan tempat peralihan dan tempat penyimpanannya; dan ii) dalam hal Informasi Rahasia berbentuk media elektronik, menggunakan program anti-virus standar yang terkini yang digunakan dalam industri dan menggunakan piranti lunak pengarsipan atas semua peralatan komputer, laptop dan komputer jinjing. ",
          },
        ],
      },
      {
        tag: "14.2",
        content:
          "Kewajiban untuk menjaga kerahasiaan sebagaimana dimaksud dalam Pasal 14 ini tidak berlaku terhadap informasi:",
        child: [
          {
            tag: "14.2.1",
            content:
              "yang ada, atau telah menjadi bagian dari ranah publik, bukan sebagai akibat dari pelanggaran atas  kewajiban  menjaga  kerahasiaan berdasarkan Perjanjian ini; atau",
          },
          {
            tag: "14.2.2",
            content:
              "telah ada di dalam penguasaan Manajer Keagenan sebelum dimulainya Perjanjian ini; atau",
          },
          {
            tag: "14.2.3",
            content: "telah diungkapkan oleh pihak ketiga yang berhak untuk mengungkapkannya; atau",
          },
          {
            tag: "14.2.4",
            content:
              "diminta untuk diungkapkan oleh hukum yang berlaku, atau atas perintah pengadilan atau badan pemerintah atau lembaga yang memiliki yurisdiksi untuk itu.",
          },
        ],
      },
      {
        tag: "14.3",
        content:
          "Setiap adanya pelanggaran dari Pasal 14 ini dapat mengakibatkan diberikannya sanksi indisipliner atau tindakan hukum yang ditetapkan kemudian oleh Perusahaan.",
      },
      {
        tag: "14.4",
        content:
          "Pasal 14 ini akan tetap berlaku meski Perjanjian Manajer Keagenan ini telah berakhir atau kadaluarsa.",
      },
    ],
  },
  {
    tag: "15.",
    content: "Pemberitahuan",
    child: [
      {
        tag: "15.1",
        content:
          "Seluruh surat menyurat, pemberitahuan, atau komunikasi apapun berdasarkan Perjanjian ini dari satu Pihak kepada Pihak lainnya wajib untuk dibuat secara tertulis dan dikirimkan melalui pos tercatat atau melalui perusahaan ekspedisi (kurir) atau kurir internal atau surat elektronik (<i>e-mail</i> atau sarana komunikasi lainnya yang akan ditentukan kemudian oleh Perusahaan) dengan alamat sebagaimana tertera dalam Perjanjian ini, atau perubahannya sebagaimana diberitahukan secara tertulis dari waktu ke waktu.",
      },
      {
        tag: "15.2",
        content:
          "Surat-menyurat atau pemberitahuan-pemberitahuan dan/atau komunikasi ke alamat tersebut di atas, dianggap telah diterima dengan ketentuan sebagai berikut:",
        child: [
          {
            tag: "15.2.1",
            content:
              "Pada hari yang sama, apabila diserahkan langsung yang dibuktikan dengan tanda tangan penerima pada buku pengantar surat (ekspedisi) atau tanda terima lain yang diterbitkan oleh Para Pihak.",
          },
          {
            tag: "15.2.2",
            content:
              "Pada hari kerja berikutnya setelah tanggal penerimaan, apabila dikirimkan melalui pos yang dibuktikan dengan resi penerimaan pos tercatat.",
          },
        ],
      },
      {
        tag: "15.3",
        content:
          "Dalam hal terjadi perubahan alamat Para Pihak, maka perubahan tersebut harus diberitahukan secara tertulis kepada Pihak lainnya dalam Perjanjian ini selambat-lambatnya 5 (lima) hari kerja sebelum perubahan alamat dimaksud berlaku efektif.",
      },
      {
        tag: "15.4",
        content:
          "Jika perubahan alamat tidak diberitahukan, maka surat-menyurat atau pemberitahuan-pemberitahuan sehubungan dengan Perjanjian ini dianggap telah diterima apabila dikirim dengan cara sebagaimana diatur dalam Pasal 15.1 dan Pasal 15.2 Perjanjian ini, dan ditujukan ke alamat di atas atau alamat sebagaimana diubah sesuai dengan Pasal 15.3 Perjanjian ini.",
      },
    ],
  },
  {
    tag: "16.",
    content: "Hukum Yang Berlaku",
    subContent:
      "Perjanjian ini diatur oleh dan harus ditafsirkan serta dilaksanakan berdasarkan hukum yang berlaku di Negara Republik Indonesia.",
  },
  {
    tag: "17.",
    content: "Penyelesaian Perselisihan",
    child: [
      {
        tag: "17.1",
        content:
          "Dalam hal terjadi perselisihan di antara Para Pihak mengenai pelaksanaan Perjanjian ini, maka Para Pihak sepakat untuk terlebih dahulu menyelesaikannya secara musyawarah.",
      },
      {
        tag: "17.2",
        content:
          "Jika melalui cara penyelesaian tersebut di atas tidak tercapai kesepakatan, maka Para Pihak sepakat untuk menyelesaikannya melalui Pengadilan Negeri dan untuk itu Para Pihak memilih domisili hukum yang tetap dan tidak berubah di Pengadilan Negeri Jakarta Selatan.",
      },
    ],
  },
  {
    tag: "18.",
    content: "Lain-Lain",
    child: [
      {
        tag: "18.1",
        content: "<b>Lampiran</b>",
        subContent:
          "Lampiran dari Perjanjian ini merupakan satu kesatuan dan bagian yang tidak dapat dipisahkan serta mempunyai kekuatan hukum yang sama serta mengikat seperti halnya pasal-pasal lain dari Perjanjian ini.",
      },
      {
        tag: "18.2",
        content: "<b>Kuasa</b>",
        subContent:
          "Semua kuasa dan wewenang yang diberikan oleh Manajer Keagenan dalam Perjanjian ini merupakan bagian terpenting dan tidak terpisahkan dari Perjanjian ini dan sebagai demikian maka kuasa dan wewenang tersebut tidak dapat ditarik/dicabut kembali dan juga tidak menjadi berakhir/hapus jika Manajer Keagenan meninggal dunia atau karena timbul peristiwa apa pun dan Para Pihak dengan ini melepaskan dan menyatakan tidak berlaku Pasal 1813, Pasal 1814 dan Pasal 1816 Kitab Undang-undang Hukum Perdata.",
      },
      {
        tag: "18.3",
        content: "<b>Pengalihan</b>",
        subContent:
          "Perjanjian ini berlaku dan mengikat terhadap Para Pihak  maupun para penerima dan penerus hak dan kewajiban dalam Perjanjian ini, dengan ketentuan bahwa Manajer Keagenan tidak dapat mengalihkan  atau  melepaskan  hak  dan/atau  kewajibannya berdasarkan Perjanjian ini kepada pihak lain tanpa persetujuan tertulis terlebih dahulu dari Perusahaan.",
      },
      {
        tag: "18.4",
        content: "<b>Keabsahan Perjanjian</b>",
        subContent:
          "Apabila sebagian dari ketentuan-ketentuan dalam  Perjanjian  ini  bertentangan  dengan  peraturan perundang-undangan yang berlaku atau tidak dapat dilaksanakan karena sebab apa pun, maka hal ini tidak mempengaruhi keabsahan dan pelaksanaan dari ketentuan-ketentuan lainnya dalam Perjanjian ini.",
      },
      {
        tag: "18.5",
        content: "<b>Manajer Keagenan Bukan Karyawan</b>",
        subContent:
          "Tidak ada satu pun dari ketentuan-ketentuan dalam  Perjanjian  ini  yang  dapat  diartikan  sebagai menciptakan  hubungan  kepegawaian  antara  Perusahaan dan Manajer Keagenan baik secara tegas maupun diam-diam.",
      },
      {
        tag: "18.6",
        content: "<b>Perubahan</b>",
        child: [
          {
            tag: "18.6.1",
            content:
              "Perusahaan dapat mengubah, menambah atau memodifikasi syarat dan ketentuan dalam Perjanjian, lampiran-lampirannya, dan/atau Peraturan Keagenan dengan pemberitahuan kepada Manajer Keagenan.",
          },
          {
            tag: "18.6.2",
            content:
              "Dengan tunduk pada Pasal 18.6.1, tidak ada perubahan, penambahan atau modifikasi pada Perjanjian, lampiran-lampirannya, Peraturan Keagenan dan/atau Ketentuan <i>Overriding</i> kecuali  dibuat  secara  tertulis  dan ditandatangani oleh pihak yang berwenang dari Perusahaan. ",
          },
        ],
      },
      {
        tag: "18.7",
        content: "<b>Inkonsistensi</b>",
        subContent:
          "Dalam hal terdapat konflik atau inkonsistensi antara ketentuan yang dikeluarkan oleh Perusahaan, Perjanjian ini dan Peraturan Keagenan  maka ketentuan yang berlaku adalah ketentuan yang terbaru, kecuali ditentukan lain oleh Perusahaan.",
      },
      {
        tag: "18.8",
        content: "<b>Pelepasan</b>",
        subContent:
          "Perusahaan  tidak  akan  dianggap  telah mengesampingkan suatu ketentuan dalam Perjanjian ini, kecuali pengesampingan tersebut adalah secara tertulis  dan  ditandatangani  oleh  Perusahaan. Kelalaian Perusahaan untuk menjalankan suatu hak menurut Perjanjian ini atau kelalaian Perusahaan untuk memaksa agar Manajer Keagenan dengan taat  mematuhi  syarat-syarat  Perjanjian  ini  bukan  merupakan suatu penolakan dari syarat-syarat Perjanjian ini dan bukan dianggap sebagai suatu pengesampingan oleh Perusahaan atas haknya untuk dikemudian hari meminta kepatuhan atas syarat-syarat Perjanjian ini.",
      },
      {
        tag: "18.9",
        content: "<b>Pajak</b>",
        child: [
          {
            tag: "18.9.1",
            content:
              "Para Pihak setuju bahwa pembayaran Komisi, <i>overriding</i>, dan tunjangan apa pun menurut Perjanjian ini masih berupa pembayaran kotor (<i>gross</i>), dalam artian di dalam pembayaran tersebut termasuk Pajak Pertambahan Nilai (PPN) dan Pajak Penghasilan (PPh) serta kewajiban perpajakan lainnya sesuai dengan peraturan perpajakan yang berlaku yang menjadi tanggung jawab Agen.",
          },
          {
            tag: "18.9.2",
            content:
              "Manajer Keagenan yang sudah dikukuhkan sebagai <b>Pengusaha Kena Pajak (PKP)</b> oleh Kantor Pelayanan Pajak setempat, wajib menerbitkan Faktur Pajak selambatnya pada hari  terakhir  bulan  berjalan,  dan  mengirimkannya  kepada  Perusahaan,  selambat-lambatnya  tanggal  10  bulan  berikutnya. ",
          },
        ],
      },
      {
        tag: "18.10",
        content: "<b>Keseluruhan Perjanjian</b>",
        subContent:
          "Kecuali hal-hal yang di nyatakan dalam Perjanjian  Keagenan,  Perjanjian  ini  beserta  lampiran-lampirannya berlaku sebagai keseluruhan Perjanjian  diantara  Para  Pihak,  dan  oleh  karena  itu  menggantikan  seluruh  perjanjian-perjanjian,  kesepakatan-kesepakatan, persetujuan-persetujuan, korespondensi-korespondensi, baik verbal maupun tertulis yang pernah dilakukan oleh Para Pihak, tanpa menghapuskan hak dan tanggung jawab Para Pihak berdasarkan perjanjian-perjanjian terdahulu sampai dengan tanggal berlakunya Perjanjian ini.",
      },
      {
        tag: "18.11",
        content: "<b>Akses Informasi</b>",
        subContent:
          "Perusahaan dapat, atas kebijakan Perusahaan, sewaktu-waktu membatasi atau menutup akses informasi Manajer Keagenan terhadap sistem informasi Perusahaan.",
      },
      {
        tag: "18.12",
        content: "<b>Anti Suap dan Korupsi</b>",
        subContent:
          "Dalam  melaksanakan  kewajiban-kewajiban  berdasarkan Perjanjian Manajer Keagenan, Manajer Keagenan wajib:",
        content2:
          "Manajer Keagenan wajib segera memberitahukan Perusahaan secara tertulis atas setiap potensi pelanggaran atau pelanggaran yang terjadi atas pasal ini. Apabila Manajer Keagenan melanggar atau terdeteksi melanggar pasal ini, Perusahaan dapat setiap saat mengakhiri Perjanjian Manajer Keagenan tanpa kewajiban apapun.",
        child: [
          {
            tag: "18.12.1",
            content:
              "Tunduk  pada  seluruh  peraturan  dan perundang-undangan yang berlaku mengenai anti suap dan korupsi;",
          },
          {
            tag: "18.12.2",
            content:
              "Tidak menawarkan suap atau pembayaran fasilitasi apapun kepada pejabat publik atau pihak manapun lainnya; dan",
          },
          {
            tag: "18.12.3",
            content:
              "Tidak melakukan hal apapun yang dapat  menyebabkan  Perusahaan  atau  setiap afiliasinya melanggar peraturan perundang-undangan mengenai anti suap dan korupsi.",
          },
        ],
      },
    ],
  },
];

export const generationORNumbering = [
  {
    tag: "1)",
    content:
      "Perhitungan OR didapatkan dari seluruh produksi yang dihasilkan oleh anggota Grup AD, baik dari <i>direct group</i> AD maupun <i>indirect group</i> AD.",
  },
  {
    tag: "2)",
    content:
      "Hanya berlaku untuk produk-produk asuransi Premi Berkala (<i>Regular Premium</i>). Tidak berlaku untuk produk-produk asuransi Premi Tunggal (<i>Single Premium</i>), PRU<i>saver</i> maupun <i>Top-up</i> kecuali untuk <i>Basic Generation OR</i> generasi 1 (tidak termasuk produk PRUWorks).",
  },
  {
    tag: "3)",
    content:
      "Bagi AD 3 – EAD, apabila tidak berhasil memenuhi ketentuan <i>Basic Generation OR</i>, maka maksimum OR yang didapatkan adalah OR Generasi ke-2.",
  },
  {
    tag: "4)",
    content:
      "OR I adalah OR yang dihitung berdasarkan persentase dari KTP yang dibayarkan kepada <i>Direct Agent</i> maupun <i>Indirect Agent</i> (sebagaimana didefinisikan di bawah ini) sehubungan dengan polis-polis Premi Berkala yang pembayaran preminya diterima pada tahun pertama.",
  },
  {
    tag: "5)",
    content:
      "OR II adalah OR yang dihitung berdasarkan persentase dari KT2 yang dibayarkan kepada <i>Direct Agent</i> maupun <i>Indirect Agent</i> sehubungan dengan polis-polis Premi Berkala yang pembayaran preminya diterima pada tahun kedua.",
  },
  {
    tag: "6)",
    content:
      "OR dari Premi Tunggal (SP) & Premi <i>Top-up</i> (TU) adalah OR yang dihitung berdasarkan persentase dari komisi yang dibayarkan kepada <i>Direct Agent</i> maupun <i>Indirect Agent</i> sehubungan dengan produksi dari polis-polis Premi Tunggal dan Premi <i>Top-up</i>, baik Premi <i>Top-up</i> yang berasal dari polis-polis Premi Tunggal maupun dari polis-polis Premi Berkala (sebagaimana didefinisikan dalam Produk Asuransi)",
  },
  {
    tag: "7)",
    content:
      "OR hanya akan diperhitungkan berdasarkan komisi atas polis-polis yang telah diterbitkan oleh Prudential Indonesia dan pembayaran preminya telah diterima dan diidentifikasikan oleh Prudential Indonesia.",
  },
  {
    tag: "8)",
    content: "Dalam Ketentuan OR ini, yang dimaksud dengan:",
    child: [
      {
        tag: "a.",
        content:
          "<i>Direct Agent</i> adalah Agen yang berada langsung di bawah pengawasan Manajer Keagenan.",
      },
      {
        tag: "b.",
        content:
          "<i>Indirect Agent</i> adalah Agen dalam Grup Manajer Keagenan yang tidak secara langsung berada di bawah pengawasan Manajer Keagenan.",
      },
      {
        tag: "c.",
        content:
          "<i>Direct Unit</i> terdiri dari Manajer Keagenan itu sendiri dan para Agen yang berada di bawah pengawasan Manajer Keagenan.",
      },
      {
        tag: "d.",
        content:
          "<i>Direct Group</i> terdiri dari Manajer Keagenan itu sendiri, para agen dan/atau Manajer Keagenan (kecuali Manajer Keagenan yang sejajar atau lebih tinggi jabatannya dari Manajer Keagenan) yang berada di bawah pengawasan Manajer Keagenan baik langsung maupun tidak langsung.",
      },
      {
        tag: "e.",
        content:
          "<i>Indirect Group</i> adalah grup lain di luar <i>Direct Group</i> dari seorang Manajer Keagenan dengan jabatan AD. Grup lain tersebut terdiri dari seorang AD dengan Grup Manajer Keagenan Langsungnya, dimana AD tersebut merupakan AD yang terkait langsung dalam hubungan AD <i>on</i> AD dengannya.",
      },
    ],
  },
  {
    tag: "9)",
    content: "Penjelasan mengenai jabatan Sr. EAD.",
    subContent: "Persyaratan untuk menjadi Sr. EAD adalah sebagai berikut:",
    content2:
      "Bagi Sr. EAD yang belum memenuhi ketentuan <i>Basic Generation OR</i>, maka <i>Generation OR</i> yang didapatkan adalah dari Generasi ke-1 sampai 5, apabila di tahun berikutnya Sr. EAD masih belum memenuhi ketentuan <i>Basic Generation OR</i>, maka <i>Generation OR</i> yang didapatkan adalah dari Generasi ke-1 sampai 4, dan seterusnya sampai Generasi ke-2. Sr. EAD dapat kembali mendapatkan <i>Basic Generation OR</i> sampai Generasi ke-6 apabila memenuhi ketentuan <i>Basic Generation OR</i>.",
    contentNoFormat:
      "<b>Informasi lengkap terkait Ketentuan <i>Overriding</i> mengacu pada <i>Agency Update</i> yang berlaku</b>",
    child: [
      {
        isBulletin: true,
        tag: "",
        content: "Harus seorang EAD (AD yang memiliki kedalaman 6 generasi AD).",
      },
      {
        isBulletin: true,
        tag: "",
        content:
          "Mempunyai minimum 10 AD langsung yang berada di bawah pengawasannya sejak Promosi Manajer Keagenan tahun 2017.",
      },
    ],
  },
];

export const promotionADNumbering = [
  {
    tag: "1.",
    content:
      "Apabila seorang AAD mempunyai AAD sejajar yang sebelumnya direkrut langsung olehnya dan dipromosikan bersama-sama atau sesudah promosi dirinya, maka total produksi unit langsung dari AAD sejajar tersebut dapat diperhitungkan dengan syarat minimum total produksi unit calon AD Rp. 300.000.000. Perhitungan sejajar ini hanya selama satu tahun pertama saja di tahun berjalan di posisi yang sama untuk total perhitungan produksi unit. Untuk persyaratan minimum Agen Aktif, Agen Aktif baru dan tingkat persistensi hanya dihitung atas pencapaian calon AD.",
  },
  {
    tag: "2.",
    content:
      "AAD sejajar yang merupakan rekrutan langsung dari Calon AD akan masuk ke <i>Group</i> AD secara otomatis setelah promosi. Apabila ada AAD sejajar yang bukan merupakan rekrutan langsung tetapi berada dibawah pengawasan Manajer Keagenan yang sama dari calon AD dan ingin dimasukkan dalam <i>Group</i> AD setelah promosi, maka nama-nama mereka harus dicantumkan dalam Formulir  Aplikasi  Permohonan  Promosi  calon  AD  yang  ditandatangani oleh Manajer Keagenan Langsung.",
  },
];

export const promotionAADNumbering = [
  {
    tag: "1.",
    content:
      "Apabila seorang calon AAD mempunyai satu atau lebih Agen <b>rekrutan langsung</b> yang juga mengajukan promosi AAD pada saat bersamaan, maka produksi pribadi Agen-agen rekrutan tersebut <b>dapat diperhitungkan</b> sebagai <b>Total Produksi Calon AAD</b>. Agen-agen rekrutan langsung tersebut juga dapat diperhitungkan untuk <b>Total Agen Aktif atau Agen Aktif baru</b> calon AAD sebagai persyaratan promosi.",
  },
  {
    tag: "2.",
    content:
      "Jika terdapat lebih dari satu pengajuan promosi menjadi AAD dengan menggunakan satu Agen Aktif atau Agen Aktif baru yang sama, maka <b>perekrut langsung</b> yang berhak menggunakan Agen Aktif tersebut untuk persyaratan promosi.",
  },
  {
    tag: "3.",
    content:
      "Bagi Agen Aktif atau Agen Aktif baru yang direkrut secara tidak langsung hanya dapat digunakan oleh satu orang Agen untuk persyaratan promosi AAD dengan catatan Agen Aktif tersebut tidak mengajukan promosi secara bersamaan menjadi AAD.",
  },
];

export const backgroundParagraph = [
  {
    tag: "1.",
    content: "Kewajiban Manajer Keagenan",
    child: [
      {
        tag: "1.1",
        content: "Kepatuhan Terhadap Peraturan Yang Berlaku",
        child: [
          {
            tag: "1.1.1",
            content:
              "Manajer Keagenan wajib mematuhi dan tunduk pada ketentuan peraturan yang berlaku, Kode Etik Agen, peraturan AAJI, OJK, Peraturan Anti Pencucian Uang dan Pencegahan Pendanaan Terorisme, Peraturan Anti Suap dan Korupsi dan peraturan lainnya yang dikeluarkan oleh Perusahaan termasuk segala perubahannya.",
          },
          {
            tag: "1.1.2",
            content:
              "Bertindak jujur dan etis, termasuk secara etis menangani benturan kepentingan yang terjadi atau nyata antara hubungan pribadi dengan hubungan profesional.",
          },
          {
            tag: "1.1.3",
            content:
              "Mendahulukan kepentingan Perusahaan yang sah, menghormati dan mengaplikasikan nilai-nilai dan standar Perusahaan.",
          },
          {
            tag: "1.1.4",
            content:
              "Mempromosikan  dan  meningkatkan  citra Perusahaan dan bertindak sebagai penyedia jasa yang bertanggung jawab serta warga negara yang baik.",
          },
        ],
      },
    ],
  },
  {
    tag: "2.",
    content: "Kepatuhan Terhadap Perjanjian Manajer Keagenan",
    subContent:
      "Manajer Keagenan wajib mematuhi dan tunduk pada ketentuan sebagaimana diatur dalam Perjanjian Manajer Keagenan, termasuk dalam melaksanakan seluruh hak dan kewajibannya.",
  },
  {
    tag: "3.",
    content: "Kewajiban Terhadap Profesi",
    child: [
      {
        tag: "3.1",
        content: "Perjanjian Manajer Keagenan",
        subContent:
          "Manajer  Keagenan  wajib  memiliki  dan  menandatangani  Perjanjian Manajer Keagenan hanya dengan satu Perusahaan Asuransi Jiwa dan dengan menggunakan kartu identitas diri yang sah dan berlaku, kecuali ditentukan lain oleh peraturan perasuransian yang berlaku. Perusahaan sewaktu-waktu dapat meminta dokumen tambahan untuk melakukan verifikasi terhadap identitas diri Manajer Keagenan.",
      },
      {
        tag: "3.2",
        content: "Sertifikasi Keagenan",
        subContent:
          "Manajer Keagenan wajib memiliki sertifikasi keagenan yang dikeluarkan oleh AAJI sebelum melakukan pemasaran dan/atau penjualan produk asuransi jiwa.",
      },
      {
        tag: "3.3",
        content: "Pelatihan dan Pengembangan",
        subContent:
          "Manajer Keagenan wajib mengikuti pelatihan dan pengembangan  dasar  dan  lanjutan  untuk  meningkatkan  profesionalisme  pekerjaannya  sebagaimana  disyaratkan oleh peraturan perundang-undangan, peraturan AAJI, OJK dan peraturan Perusahaan.",
      },
    ],
  },
  {
    tag: "4.",
    content: "Kewajiban Terhadap Perusahaan",
    child: [
      {
        tag: "4.1",
        content:
          "Dalam prinsip hubungan antara Manajer Keagenan dengan Perusahaan, Manajer Keagenan harus menunjukkan kejujuran, niat baik dan kesetiaan dalam semua kegiatan keagenan.",
      },
      {
        tag: "4.2",
        content:
          "Manajer Keagenan harus secara tegas memahami dan patuh terhadap semua prosedur dan kebijakan Perusahaan yang berlaku.",
      },
      {
        tag: "4.3",
        content:
          "Manajer Keagenan wajib menggunakan dokumen pemasaran resmi dan terkini yang dikeluarkan oleh Perusahaan yang diwakilinya.",
      },
      {
        tag: "4.4",
        content:
          "Manajer  Keagenan  wajib  melakukan  kegiatan pemasaran sesuai dengan ketentuan yang berlaku di Perusahaan Asuransi Jiwa yang diwakilinya.",
      },
      {
        tag: "4.5",
        content: "Premi",
        child: [
          {
            tag: "4.5.1",
            content:
              "Manajer Keagenan wajib memberitahukan jumlah premi yang telah dibayarkan oleh calon Nasabah atau Nasabah sesuai dengan yang ditetapkan oleh Perusahaan.",
          },
          {
            tag: "4.5.2",
            content:
              "Manajer Keagenan harus bertindak sebagai pihak yang dipercaya atas beberapa tanggung jawab dan penjagaan informasi rahasia.",
          },
          {
            tag: "4.5.3",
            content:
              "Manajer  Keagenan  tidak  dibolehkan  menggunakan  setiap  dan  seluruh  aset  Perusahaan  termasuk  laporan,  materi pelatihan, brosur, literatur dan/atau materi lain selain untuk tujuan yang bermanfaat bagi Perusahaan.",
          },
        ],
      },
      {
        tag: "4.6",
        content: "Hak Milik Intelektual",
        child: [
          {
            tag: "4.6.1",
            content:
              "Manajer  Keagenan  wajib  mendapatkan  persetujuan dari Perusahaan yang diwakilinya dalam  hal  Manajer  Keagenan  bermaksud  menggunakan karya cipta, paten, merek dan/atau logo, termasuk namun tidak terbatas pada piranti lunak komputer (<i>software</i>) dari Perusahaan.",
          },
          {
            tag: "4.6.2",
            content:
              "Manajer Keagenan tidak diizinkan untuk menggunakan logo atau merek Prudential (dengan logo atau merk lain atau untuk tujuan bisnis lainnya) selain dari penggunaan yang telah disetujui oleh Perusahaan dan Manajer Keagenan tidak diizinkan untuk mengubah/menambah hak atas Kekayaan Intelektual Perusahaan dengan berbagai cara apapun yang dapat membawa risiko atau merusak reputasi baik Perusahaan.",
          },
        ],
      },
      {
        tag: "4.7",
        content: "Kepemilikan dan Kerahasiaan Atas Data Nasabah",
        subContent:
          "Setiap data Nasabah adalah milik dari Perusahaan. Manajer Keagenan dilarang untuk memberitahukan kepada pihak ketiga dan/atau menggunakan data Nasabah dan informasi lainnya yang didapatkan dalam rangka menjalankan kewajibannya sebagai Manajer Keagenan termasuk informasi mengenai Perusahaan kepada pihak ketiga selain untuk kepentingan Perusahaan, kecuali:",
        child: [
          {
            tag: "4.7.1",
            content:
              "setelah mendapat persetujuan dari Perusahaan dalam hal informasi yang berkaitan dengan Perusahaan, atau dari Perusahaan, AAJI, OJK dan Nasabah dalam hal berkaitan dengan data Nasabah, atau",
          },
          {
            tag: "4.7.2",
            content:
              "untuk melaksanakan perintah dari pejabat pemerintah, AAJI, OJK dan pengadilan berdasarkan peraturan yang berlaku.",
          },
        ],
      },
      {
        tag: "4.8",
        content: "SPAJ dan Kelengkapannya",
        subContent:
          "Manajer Keagenan wajib selalu memastikan bahwa Nasabah memberikan informasi yang jelas, benar dan lengkap dalam pengisian SPAJ maupun semua dokumen kelengkapan lainnya. Manajer Keagenan dilarang memanipulasi dan merubah data-data yang diberikan oleh Nasabah (kecuali dengan persetujuan tertulis terlebih dahulu dari Nasabah dan Perusahaan dalam hal polis telah diterbitkan).",
      },
      {
        tag: "4.9",
        content: "Laporan Manajer Keagenan",
        subContent:
          "Dalam setiap permohonan asuransi jiwa dari calon Nasabah, Manajer Keagenan wajib senantiasa memberikan informasi yang jelas, benar dan lengkap tentang Nasabah dalam laporan Manajer Keagenan sebagaimana ditetapkan oleh Perusahaan.",
      },
      {
        tag: "4.10",
        content: "Tindak  Pidana  Pencucian  Uang  <i>(Anti  Money  Laundering)</i>",
        subContent:
          "Manajer Keagenan wajib senantiasa mematuhi segala aturan  dan  ketentuan  tentang  tindak  pidana pencucian uang yang ditetapkan oleh Perusahaan dan peraturan perundang-undangan serta wajib mengikuti pelatihan-pelatihan mengenai anti pencucian uang yang diselenggarakan oleh Perusahaan sebagaimana ditetapkan oleh perundang-undangan dan aturan pemerintah yang berlaku.",
      },
      {
        tag: "4.11",
        content: "<i>Pooling</i>",
        subContent:
          "Manajer Keagenan dilarang untuk mengalihkan penjualan produk yang telah dilakukannya kepada Manajer Keagenan atau Agen lainnya. Manajer Keagenan atau Agen yang tercatat dalam dokumen SPAJ merupakan Manajer Keagenan atau Agen yang melakukan prospek, presentasi dan penjualan kepada calon Nasabah atau Nasabah hingga pada saat calon Nasabah atau Nasabah melakukan penandatanganan SPAJ tersebut. Manajer Keagenan wajib menolak namanya dicantumkan dalam dokumen SPAJ apabila dirinya tidak melakukan prospek atau penjualan produk asuransi jiwa kepada calon Nasabah atau Nasabah.",
      },
      {
        tag: "4.12",
        content: "Rekrutmen Agen",
        subContent:
          "Dengan  tetap  mengindahkan  peraturan  dan  perundang-undangan yang berlaku, setiap Manajer Keagenan yang melakukan perekrutan Agen bagi Perusahaan wajib memastikan bahwa Agen yang akan direkrut menyerahkan:",
        child: [
          {
            tag: "4.12.1",
            content:
              "Salinan surat pengunduran diri Agen dari Perusahaan Asuransi Jiwa terdahulu (apabila pengakhiran Perjanjian Keagenan terjadi karena Agen mengundurkan diri) dan Salinan surat persetujuan Perusahaan Asuransi Jiwa atas pengunduran diri Agen tersebut. Salinan surat persetujuan Perusahaan Asuransi Jiwa atas pengunduran diri Agen tidak diperlukan apabila Perusahaan Asuransi Jiwa  terdahulu tidak mengeluarkan surat persetujuan dalam jangka waktu 30 (tiga puluh) hari sejak surat pengunduran diri tersebut diterima oleh Perusahaan Asuransi Jiwa terdahulu; atau salinan surat pengakhiran Perjanjian Keagenan (apabila pengakhiran Perjanjian Keagenan terjadi karena pemutusan perjanjian oleh Perusahaan Asuransi Jiwa terdahulu).",
          },
          {
            tag: "4.12.2",
            content:
              "Salinan surat pernyataan Agen yang berpindah dari suatu Perusahaan Asuransi Jiwa ke Perusahaan Asuransi Jiwa Iainnya untuk tidak melakukan  <i>Twisting</i>.  Definisi  <i>Twisting</i>  dijelaskan pada pasal 5.1 dalam Lampiran III ini.",
          },
        ],
      },
      {
        tag: "4.13",
        content: "Perpindahan Manajer Keagenan",
        subContent:
          "Apabila Manajer Keagenan bermaksud untuk pindah dari suatu Perusahaan Asuransi Jiwa ke Perusahaan Asuransi Jiwa lainnya, maka Manajer Keagenan wajib melakukan perpindahan sesuai dengan ketentuan dalam peraturan dan perundang-undangan yang berlaku dan wajib menyerahkan kepada Perusahaan Asuransi Jiwa terdahulu:",
        child: [
          {
            tag: "4.13.1",
            content: "Asli surat pengunduran diri.",
          },
          {
            tag: "4.13.2",
            content:
              "Asli surat pernyataan Manajer Keagenan yang berpindah untuk tidak melakukan <i>Twisting</i>. Dan selanjutnya wajib menyerahkan kepada Perusahaan Asuransi Jiwa yang baru:",
            child: [
              {
                tag: "a.",
                isTagNumber: true,

                content:
                  "Salinan surat pengunduran diri (apabila pengakhiran Perjanjian Keagenan terjadi karena mengundurkan diri) dan Salinan surat persetujuan Perusahaan Asuransi Jiwa atas pengunduran diri tersebut. Salinan surat persetujuan Perusahaan atas pengunduran diri tidak diperlukan apabila Perusahaan Asuransi Jiwa terdahulu tidak mengeluarkan surat persetujuan dalam jangka waktu 30 (tiga puluh) hari sejak surat pengunduran diri tersebut diterima oleh Perusahaan Asuransi Jiwa terdahulu; atau salinan surat pengakhiran Perjanjian Keagenan (apabila pengakhiran Perjanjian Keagenan terjadi karena pemutusan perjanjian oleh Perusahaan Asuransi Jiwa terdahulu).",
              },
              {
                tag: "b.",
                isTagNumber: true,
                content:
                  "Salinan  surat  pernyataan  Manajer Keagenan yang akan berpindah untuk tidak melakukan <i>Twisting.</i> ",
              },
            ],
          },
        ],
      },
      {
        tag: "4.14",
        content: "Keterbukaan",
        subContent:
          "Manajer Keagenan wajib setiap saat memberikan informasi yang jelas, benar, dan lengkap kepada Perusahaan, calon Nasabah dan Nasabah. Manajer Keagenan dilarang menyampaikan informasi yang bersifat keliru dan menyesatkan kepada Perusahaan, calon Nasabah dan Nasabah.",
      },
      {
        tag: "4.15",
        content: "Bantuan Investigasi, Pemeriksaan dan Audit",
        subContent:
          "Manajer Keagenan wajib senantiasa memberikan bantuan yang wajar kepada Perusahaan dalam hal terjadi investigasi atau pemeriksaan terkait usaha perasuransian, baik dari tim pemeriksa Perusahaan sendiri, pihak ketiga maupun dari pihak yang berwenang dari pemerintah. Bantuan tersebut termasuk tapi tidak terbatas pada memberikan kesempatan, akses terhadap data-data terkait yang ada pada Manajer Keagenan.",
      },
      {
        tag: "4.16",
        content: "Presentasi Penjualan",
        subContent:
          "Manajer Keagenan dalam melakukan pemasaran dan/atau penjualan wajib memastikan, termasuk tapi tidak terbatas atas hal-hal sebagai berikut:",
        child: [
          {
            tag: "4.16.1",
            content:
              "Manajer Keagenan wajib menerangkan dan memberikan penjelasan mengenai ringkasan informasi produk kepada calon Nasabah atau Nasabah.",
          },
          {
            tag: "4.16.2",
            content:
              "Calon Nasabah atau Nasabah telah memahami produk asuransi yang hendak dibeli termasuk  namun  tidak  terbatas  pada  ketentuan mengenai resiko, premi dan manfaat asuransi.",
          },
          {
            tag: "4.16.3",
            content:
              "Manajer  Keagenan  wajib  meminta  calon Nasabah atau Nasabah untuk mengisi formulir SPAJ sendiri, jika calon Nasabah atau Nasabah tidak dapat melakukannya, Manajer Keagenan wajib menjelaskan formulir SPAJ tersebut kepada calon Nasabah atau Nasabah dan membacakan pertanyaan-pertanyaan yang harus dijawab calon Nasabah atau Nasabah sehingga calon Nasabah atau Nasabah mengerti dan bisa mendiktekan jawabannya.",
          },
          {
            tag: "4.16.4",
            content:
              "Calon Nasabah atau Nasabah telah memahami bahwa calon Nasabah atau Nasabah wajib mengungkapkan dengan jujur segala informasi yang berkaitan dengan riwayat kesehatan, usia, pekerjaan dan hal-hal lain yang dapat mempengaruhi keputusan Perusahaan dalam hal penjualan produk asuransi atau besarnya premi kepada calon Nasabah atau Nasabah.",
          },
        ],
      },
      {
        tag: "4.17",
        content: "Manipulasi Penjualan",
        subContent:
          "Manajer Keagenan dilarang untuk memanipulasi penjualan untuk tujuan mendapatkan insentif atau memenangkan kontes atau <i>award</i>. Termasuk contoh dalam kegiatan memanipulasi penjualan adalah melakukan bujukan untuk mengakhiri polis segera setelah mendapatkan insentif atau memenangkan kontes atau <i>award</i>.",
      },
      {
        tag: "4.18",
        content: "Pencemaran Nama Baik",
        subContent:
          "Manajer Keagenan dilarang mencemarkan nama baik dan reputasi Perusahaan dan lembaga asuransi lainnya.",
      },
      {
        tag: "4.19",
        content: "Pelaporan Pelanggaran",
        subContent:
          "Manajer Keagenan wajib melaporkan kepada Perusahaan jika ia mengetahui adanya Manajer Keagenan atau Agen lain atau Tenaga Pemasar Non Agen lain yang melakukan pelanggaran atas Kode Etik Agen ini dan atau peraturan perasuransian yang berlaku.",
      },
      {
        tag: "4.20",
        content:
          "Persekongkolan  Manajer  Keagenan  untuk  menghilangkan, menghapus atau mengubah informasi mengenai (calon) Nasabah akan dianggap sebagai tindakan tidak beretika dan penipuan.",
      },
      {
        tag: "4.21",
        content:
          "Manajer Keagenan harus mengetahui dan mengerti Produk Asuransi Perusahaan yang mereka pasarkan.",
      },
      {
        tag: "4.22",
        content:
          "Manajer  Keagenan  tidak  diperkenankan  untuk merekrut dan merekomendasikan agen-agen atau nasabah-nasabah yang diketahui memiliki moral dan standar etika yang buruk.",
      },
      {
        tag: "4.23",
        content:
          "Manajer  Keagenan  bertanggung  jawab  untuk  bertindak selaku <i>field underwriter</i> untuk Perusahaan, bertemu secara langsung dengan (calon) Nasabah dan (calon) Tertanggung untuk mengumpulkan informasi yang lengkap dan tepat sehubungan dengan (calon) Nasabah dan (calon) Tertanggung  mengenai risiko yang dapat timbul untuk disampaikan secara lengkap kepada Perusahaan.",
      },
      {
        tag: "4.24",
        content: "Keterlibatan dalam aktivitas pencucian uang",
        subContent:
          "Membantu Nasabah memanfaatkan polis asuransi untuk mengubah identitas dana yang diperoleh dari aktivitas ilegal supaya tampak berasal dari sumber yang sah.",
      },
    ],
  },
  {
    tag: "5.",
    content: "Kewajiban  Manajer  Keagenan  Kepada  Nasabah",
    child: [
      {
        tag: "5.1",
        content:
          "Manajer Keagenan dilarang untuk melakukan tindakan Pemutarbalikan (<i>Twisting</i>) dan Pencampuradukan <i>(Churning)</i>",
        subContent:
          "<i>Twisting</i> adalah tindakan Tenaga Pemasar yang membujuk dan/atau mempengaruhi pemegang polis untuk merubah spesifikasi polis yang ada atau mengganti polis yang ada dengan polis yang baru pada Perusahaan Asuransi Jiwa lainnya dan/atau membeli polis baru dengan menggunakan dana yang berasal dari polis yang masih aktif pada suatu Perusahaan Asuransi Jiwa lainnya dalam waktu 6 (enam) bulan sebelum dan sesudah tanggal polis baru di Perusahaan Asuransi Jiwa lain diterbitkan.",
        content2:
          "<i>Twisting Internal</i> atau <i>Churning</i> adalah tindakan membujuk dan mempengaruhi pemegang polis untuk merubah spesifikasi polis yang ada atau mengganti polis yang ada dengan polis yang baru pada Perusahaan Asuransi Jiwa yang sama, dan/atau membeli polis baru dengan menggunakan dana yang berasal dari polis yang masih aktif dari Perusahaan Asuransi Jiwa yang sama tanpa penjelasan terlebih dahulu kepada pemegang polis mengenai kerugian yang dapat diderita oleh pemegang polis akibat perubahan penggantian tersebut.  <i>Twisting Internal</i> atau <i>Churning</i> mengacu pada peraturan Perusahaan yang diterbitkan dari waktu ke waktu.",
      },
      {
        tag: "5.2",
        content: "Pengisian Formulir",
        subContent: "Manajer Keagenan dilarang untuk: ",
        child: [
          {
            tag: "5.2.1",
            content:
              "Meminta atau membiarkan calon Nasabah dan/atau Nasabah untuk menandatangani SPAJ kosong atau formulir asuransi kosong lainnya.",
          },
          {
            tag: "5.2.2",
            content:
              "Menandatangani atau membubuhkan paraf atau tanda tangan calon Nasabah dan/atau Nasabah, walaupun calon Nasabah dan/atau Nasabah tersebut menyetujuinya.",
          },
          {
            tag: "5.2.3",
            content:
              "Manajer Keagenan dilarang membuat laporan apabila Manajer Keagenan tidak bertemu/berhadapan langsung dengan (calon) Nasabah dan/atau  (calon)  Tertanggung  dan  menyaksikan sendiri (calon) Nasabah dan/atau  (calon)  Tertanggung  mengisi  dan menandatangani SPAJ dan formulir asuransi lainnya.",
          },
        ],
      },
      {
        tag: "5.3",
        content: "Penyalahgunaan Dana Nasabah <i>(Misappropriation of Funds)</i>",
        subContent:
          "Manajer Keagenan dilarang untuk mengambil atau menyalahgunakan pembayaran premi, uang atau harta benda lain milik Perusahaan yang diterima dari calon Nasabah dan/atau Nasabah. Penundaan penyetoran premi yang diterima dari Nasabah atau calon Nasabah kepada Perusahaan setelah melewati jangka waktu 48 (empat puluh delapan) jam terhitung sejak Manajer Keagenan menerima premi termasuk juga dalam kategori penyalahgunaan dana.",
      },
      {
        tag: "5.4",
        content: "Penyerahan Dokumen Kepada Nasabah",
        subContent:
          "Perusahaan dapat sewaktu-waktu mempercayakan dokumen-dokumen Nasabah seperti polis atau dokumen lainnya kepada Manajer Keagenan untuk diserahkan dengan segera kepada Nasabah. Manajer Keagenan wajib menyerahkan polis atau dokumen dari Perusahaan kepada Nasabah serta mendapatkan tanda terima.",
        content2:
          "Selanjutnya Manajer Keagenan wajib menyerahkan tanda terima dokumen tersebut kepada Perusahaan. Manajer Keagenan wajib segera memberitahukan kepada Perusahaan apabila ia gagal mengirimkan dokumen-dokumen tersebut kepada Nasabah beserta alasannya dan segera mengembalikan dokumen-dokumen tersebut kepada Perusahaan.",
      },
      {
        tag: "5.5",
        content: "Pendanaan dan Pembayaran Atas Premi",
        subContent:
          "Manajer  Keagenan  dilarang  untuk  melakukan pendanaan kewajiban pembayaran premi Nasabah terhadap Perusahaan dengan dananya sendiri, baik hal yang merupakan pembayaran dimuka (premi pertama) atau pembayaran premi lanjutan kecuali Manajer Keagenan tersebut memiliki hubungan suami istri atau keluarga sedarah dalam satu garis ke atas dan ke bawah dengan Nasabah.",
      },
      {
        tag: "5.6",
        content: "Diskon, <i>Rebate</i> dan <i>Inducement</i>",
        child: [
          {
            tag: "5.6.1",
            content:
              "Kecuali  ditentukan  lain  dalam  Peraturan Manajer Keagenan, Manajer Keagenan dilarang baik secara langsung maupun tidak langsung menawarkan dan/atau menjanjikan dan/atau memberikan potongan/diskon bagi calon Nasabah atau  Nasabah  sehubungan  dengan  pembayaran premi sehingga jumlah premi yang dibayar untuk suatu polis lebih rendah dari jumlah premi yang tertera dalam polis atau menawarkan potongan komisi kepada Nasabah atau calon Nasabah sebagai alat untuk membujuk/mendorong agar calon Nasabah atau Nasabah membeli polis dari Manajer Keagenan.",
          },
          {
            tag: "5.6.2",
            content:
              "Manajer Keagenan dilarang baik secara langsung maupun tidak langsung menjanjikan untuk memberikan dan/atau memberikan benda lain yang berharga yang dimaksudkan untuk memberikan potongan premi kepada calon Nasabah atau Nasabah.",
          },
          {
            tag: "5.6.3",
            content:
              "Manajer Keagenan dilarang baik secara langsung maupun tidak langsung meminta atau menerima hadiah, manfaat atau pemberian dari Nasabah sebagai balasan untuk setiap jasa yang dilakukan Manajer Keagenan.",
          },
        ],
      },
      {
        tag: "5.7",
        content: "Penerima Manfaat",
        subContent:
          "Manajer Keagenan dilarang menjadi penerima manfaat dari tertanggung, kecuali terdapat hubungan <i>insurable interest</i> antara tertanggung dan Manajer Keagenan tersebut.",
      },
      {
        tag: "5.8",
        content: "Pemasaran dan Presentasi",
        subContent:
          "Manajer Keagenan melakukan penjualan produk asuransi berdasarkan kebutuhan calon Nasabah atau Nasabah. Dengan demikian Manajer Keagenan wajib:",
        child: [
          {
            tag: "5.8.1",
            content:
              "Memperlihatkan  sertifikasi  keagenannya  kepada calon Nasabah atau Nasabah sebelum memulai proses pemasaran dan penjualan.",
          },
          {
            tag: "5.8.2",
            content: "Mengenali kebutuhan calon Nasabah atau Nasabah.",
          },
          {
            tag: "5.8.3",
            content:
              "Pada saat wawancara pertama dengan calon Nasabah atau Nasabah, Manajer Keagenan wajib  meluangkan  cukup  waktu  untuk  membicarakan konsep asuransi, rencana keuangan dan melakukan analisa kebutuhan calon Nasabah atau Nasabah akan produk asuransi.",
          },
          {
            tag: "5.8.4",
            content:
              'Mengaplikasikan  prinsip/aturan  "KENALI NASABAH ANDA" sebagaimana diatur dalam peraturan yang berlaku.',
          },
          {
            tag: "5.8.5",
            content:
              "Mengajukan pertanyaan yang tepat untuk menentukan jika satu produk cocok untuk calon Nasabah atau Nasabah. Manajer Keagenan wajib mendengarkan tujuan dan kebutuhan calon Nasabah atau Nasabah yang diungkapkan untuk dapat menilai produk asuransi yang cocok untuk calon Nasabah atau Nasabah.",
          },
          {
            tag: "5.8.6",
            content:
              "Menilai secara tepat apakah satu produk asuransi yang disarankan cocok untuk calon Nasabah atau Nasabah, informasi atas pertanyaan berikut dapat dijadikan acuan, antara lain:",
            child: [
              {
                tag: "a.",
                isTagNumber: true,

                content: "Apa pekerjaan, usaha dan posisi dari calon Nasabah atau Nasabah?",
              },
              {
                tag: "b.",
                isTagNumber: true,

                content: "Berapa usia calon Nasabah atau Nasabah?",
              },
              {
                tag: "c.",
                isTagNumber: true,

                content:
                  "Dimana dia tinggal? Apakah lingkungan tempat tinggalnya di kalangan atas?",
              },
              {
                tag: "d.",
                content:
                  "Apakah menikah, siapa suami/istri dari calon  Nasabah  atau  Nasabah  dan  bagaimana status pernikahannya?",
                isTagNumber: true,
              },
              {
                tag: "e.",
                content: "Apa hobi calon Nasabah atau Nasabah? Apakah hobi tersebut umum?",
                isTagNumber: true,
              },
              {
                tag: "f.",
                content: "Berapa penghasilan calon Nasabah atau Nasabah?",
                isTagNumber: true,
              },
              {
                tag: "g.",
                content: "Siapa saja dan berapa banyak jumlah tanggungannya?",
                isTagNumber: true,
              },
            ],
          },
          {
            tag: "5.8.7",
            content:
              "Menjelaskan secara lengkap mengenai produk asuransi yang akan dipasarkan termasuk mengenai:",
            child: [
              {
                tag: "a.",
                content: "Fitur produk asuransi.",
                isTagNumber: true,
              },
              {
                tag: "b.",
                content: "Manfaat produk asuransi.",
                isTagNumber: true,
              },
              {
                tag: "c.",
                content: "Persyaratan-persyaratan yang berkaitan dengan produk asuransi.",
                isTagNumber: true,
              },
              {
                tag: "d.",
                content:
                  "Memelihara  tingkat  profesionalisme  dengan selalu mendapatkan informasi terbaru mengenai produk Perusahaan, kebijakan dan ketentuan Perusahaan.",
                isTagNumber: true,
              },
              {
                tag: "e.",
                content:
                  "Memastikan bahwa setiap pertanyaan yang terdapat dalam SPAJ telah dipahami oleh Calon Nasabah atau Nasabah.",
                isTagNumber: true,
              },
              {
                tag: "f.",
                isTagNumber: true,

                content:
                  "Dalam hal Nasabah memilih pengiriman polis melalui Manajer Keagenan, maka Manajer Keagenan sangat disarankan untuk mengantar sendiri polis kepada Nasabah  segera  untuk  menjelaskan kembali spesifikasi Produk Asuransi yang dibeli dan menegaskan keinginan Nasabah membeli Produk Asuransi tersebut. Manajer Keagenan harus meminta bukti penerimaan polis dari Nasabah.",
              },
            ],
          },
        ],
      },
      {
        tag: "5.9",
        content: "Benturan Kepentingan",
        subContent:
          "Manajer  Keagenan  tidak  boleh  merugikan kepentingan calon Nasabah atau Nasabah atau Perusahaan untuk suatu tujuan guna mendapatkan  keuntungan  pribadi.  Manajer  Keagenan  wajib  memberitahukan  kepada  calon  Nasabah  atau  Nasabah mengenai hal-hal yang dimiliki oleh Manajer  Keagenan  yang  memiliki  potensi  benturan kepentingan terhadap kepentingan kebutuhan calon Nasabah  atau  Nasabah  dan/atau  dapat mempengaruhi obyektivitas dan independensi Manajer Keagenan dalam memberikan nasihat keuangan kepada calon Nasabah atau Nasabah. Manajer Keagenan juga tidak dapat memberikan  nasihat  keuangan  di  luar  kapasitas  dan pengetahuannya selaku pemasar produk asuransi jiwa Perusahaan.",
      },
      {
        tag: "5.10",
        content: "Misrepresentasi",
        child: [
          {
            tag: "5.10.1",
            content: "Ilustrasi",
            subContent:
              "Manajer  Keagenan  wajib  menyediakan/menyampaikan informasi mengenai produk secara benar, tepat, lengkap dan dalam Bahasa yang sederhana dengan mengacu pada ketentuan dari Perusahaan melalui materi atau alat yang telah disediakan oleh Perusahaan. Manajer  Keagenan  dilarang  membuat  perubahan terhadap ilustrasi yang disediakan Perusahaan tanpa seijin dari Perusahaan.",
          },
          {
            tag: "5.10.2",
            content: "Pernyataan yang menyesatkan",
            subContent:
              "Manajer  Keagenan  dilarang  membuat  pernyataan yang menyesatkan dalam proses kegiatan penjualan atau pemasaran mereka. Informasi  yang  penting  sebagai  dasar pengambilan keputusan harus secara penuh dan akurat diungkapkan sebelum dan pada saat penjualan dilakukan.",
          },
          {
            tag: "5.10.3",
            content: "Perbandingan yang tidak lengkap",
            subContent:
              "Manajer Keagenan dilarang memberikan perbandingan yang tidak lengkap atau tidak benar dari setiap polis dari suatu Perusahaan dengan yang lainnya dengan niat untuk meyakinkan Nasabah dalam membeli produk asuransi, atau untuk mengakhiri atau menebus polis.",
          },
        ],
      },
      {
        tag: "5.11",
        content: "Pelayanan",
        subContent:
          "Manajer Keagenan wajib memberikan pelayanan secara profesional, menyeluruh, efisien, konsisten dan berkelanjutan kepada Nasabah dan Perusahaan. Untuk  itu,  Manajer  Keagenan  wajib  memiliki pengetahuan yang memadai tentang produk asuransi Perusahaan dan prinsip-prinsip asuransi.",
      },
      {
        tag: "5.12",
        content: "Pemalsuan",
        subContent:
          "Manajer Keagenan dilarang memalsukan dokumen baik secara langsung maupun tidak langsung. Memalsukan tanda tangan Nasabah baik secara langsung atau tidak langsung terhadap setiap dokumen yang berkaitan dengan bisnis Perusahaan. Tuduhan atau kecurigaan atas pelanggaran diatas akan diinvestigasi oleh Perusahaan untuk selanjutnya diambil tindakan yang tegas",
      },
      {
        tag: "5.13",
        content: "Manajer Keagenan yang tidak berwenang",
        subContent:
          "Manajer Keagenan dilarang baik secara langsung maupun  tidak  langsung  menunjuk,  meminta,  menginstruksikan,  memberikan  kuasa  kepada  seseorang yang dikenal yang tidak berwenang atau tidak mempunyai lisensi untuk memasarkan polis atas nama Manajer Keagenan.",
      },
    ],
  },
  {
    tag: "6.",
    content: "Hubungan dengan Rekan Seprofesi",
    child: [
      {
        tag: "6.1",
        content:
          "Hubungan dengan sesama Manajer Keagenan atau rekan seprofesi Perusahaan harus dilandasi sikap saling menghargai dan mempercayai. Sangat dianjurkan untuk membina hubungan baik dengan kantor keagenan lain, menciptakan persaingan usaha yang sehat dan memotivasi sesama Manajer Keagenan untuk menerapkan standar yang sama.",
      },
      {
        tag: "6.2",
        content:
          "Manajer Keagenan tidak dibolehkan untuk mengambil atau membujuk Nasabah dan/atau calon Nasabah Manajer Keagenan atau Agen lain untuk mengganti Manajer Keagenan atau Agen.",
      },
      {
        tag: "6.3",
        content:
          "Keberatan-keberatan terhadap tindakan sesama Manajer Keagenan atau rekan dalam Perusahaan yang dianggap bertentangan dengan Kode Etik ini harus diajukan kepada pegawai yang ditunjuk Perusahaan untuk bertanggung jawab atas Manajer Keagenan dan tidak dibenarkan untuk disampaikan kepada pihak luar Perusahaan termasuk penyiaran melalui media massa, sosial media atau media komunikasi lainnya diluar Perusahaan.",
      },
      {
        tag: "6.4",
        content:
          "Manajer Keagenan dilarang membujuk Agen lain untuk pindah ke unit atau kantor keagenan lain.  Dalam hal perpindahan tersebut merupakan tindakan yang harus dilakukan dalam melaksanakan Kode Etik ini, maka Manajer Keagenan yang baru harus mendiskusikan situasi tersebut dengan Manajer Keagenan atau kantor keagenan yang berkaitan dan wakil yang ditunjuk Perusahaan.",
      },
    ],
  },
  {
    tag: "7.",
    content: "Sanksi Pelanggaran Kode Etik",
    child: [
      {
        tag: "7.1",
        content:
          "Setiap tindakan yang dianggap sebagai pelanggaran terhadap Kode Etik ini akan diinvestigasi oleh Perusahaan. Setelah selesainya proses investigasi, Perusahaan akan memutuskan tindakan disiplin yang tepat terhadap Manajer Keagenan yang melanggar Kode Etik ini antara lain, berupa:",
        child: [
          {
            tag: "7.1.1",
            content: "Peringatan tertulis;",
          },
          {
            tag: "7.1.2",
            content:
              "Pelaporan pelanggaran Agen kepada AAJI untuk dimasukkan ke dalam Daftar Tenaga Pemasar Bermasalah dan/atau untuk dilakukan pencabutan sertifikasi keagenan;",
          },
          {
            tag: "7.1.3",
            content: "Penonaktifan Agen sementara <i>(skorsing)</i>; dan/atau",
          },
          {
            tag: "7.1.4",
            content:
              "Pengakhiran Perjanjian Manajer Keagenan, Pengenaan sanksi dapat dilakukan secara sekaligus  bergantung  kepada  jenis pelanggaran ketentuan Kode Etik Agen.",
          },
        ],
      },
      {
        tag: "7.2",
        content:
          "AAJI dapat mengenakan sanksi kepada setiap Manajer Keagenan yang melakukan pelanggaran Kode Etik Agen berdasarkan pelaporan tertulis dari Perusahaan yang antara lain berupa:",
        child: [
          {
            tag: "7.2.1",
            content: "Pencabutan sertifikasi keagenan; dan/atau",
          },
          {
            tag: "7.2.2",
            content: "Pencantuman pada Daftar Tenaga Pemasar Bermasalah.",
          },
        ],
      },
      {
        tag: "7.3",
        content:
          "Pencabutan  sertifikasi  keagenan  dan/atau  pencantuman  dalam  Daftar  Tenaga  Pemasar Bermasalah dapat dilakukan oleh AAJI dalam hal Manajer Keagenan terbukti:",
        child: [
          {
            tag: "7.3.1",
            content:
              "Melakukan  kegiatan  pemasaran  produk  asuransi jiwa tanpa memiliki sertifikasi yang sah dan masih berlaku dari AAJI;",
          },
          {
            tag: "7.3.2",
            content: "Melakukan tindak pidana yang terkait dengan usaha perasuransian;",
          },
          {
            tag: "7.3.3",
            content: "Membantu dan/atau memfasilitasi tindak pidana pencucian uang;",
          },
          {
            tag: "7.3.4",
            content: "Melakukan Twisting; atau",
          },
          {
            tag: "7.3.5",
            content: "Melakukan pelanggaran berat lainnya.",
          },
        ],
      },
      {
        tag: "7.4",
        content:
          "Sanksi pencabutan sertifikasi Agen dan sanksi pencantuman  dalam  Daftar  Tenaga  Pemasar Bermasalah berlaku untuk jangka waktu paling sedikit 5 (lima) tahun.",
      },
    ],
  },
  {
    tag: "8.",
    content: "Pelaksanaan Kode Etik",
    child: [
      {
        tag: "8.1",
        content: "Setiap Manajer Keagenan wajib mematuhi dan tunduk kepada Kode Etik ini.",
      },
      {
        tag: "8.2",
        content:
          "Apabila dianggap perlu oleh Perusahaan, maka Perusahaan berhak untuk mengubah Kode Etik ini setiap saat.",
      },
    ],
  },
];
